/**
 * Suomenkielinen sanasto — ja samalla käännösten tyyppi.
 *
 * Tämä tiedosto on ainoa lähde sille, mitä avaimia on olemassa: `en.ts`
 * julistetaan tyypiksi `Sanasto`, joten puuttuva avain, ylimääräinen avain
 * tai eri parametrit ovat käännösvirheitä eivätkä puuttuvaa tekstiä
 * ajossa.
 *
 * Arvo on joko merkkijono tai funktio. Funktio siksi, ettei sanastoon
 * tarvita omaa mallinnekieltään: taivutus, monikko ja lukujen paikka
 * ratkeavat kielen omassa tiedostossa, jossa niistä myös tietää.
 *
 * Avaimet on nimetty näkymän mukaan (`kalenteri.*`), ja `yleinen.*` on
 * niille sanoille, jotka toistuvat kaikkialla. Sanoja ei jaeta uudelleen
 * käytettäviksi paloiksi lauseen keskeltä: lauseen rakenne vaihtuu
 * kielestä toiseen, ja koottu lause on juuri se, mikä silloin hajoaa.
 */

export const fi = {
  // --- Yleiset ------------------------------------------------------------
  'yleinen.ladataan': 'Ladataan…',
  'yleinen.haetaan': 'Haetaan…',
  'yleinen.tallenna': 'Tallenna',
  'yleinen.tallennetaan': 'Tallennetaan…',
  'yleinen.tallennettu': 'Tallennettu.',
  'yleinen.peruuta': 'Peruuta',
  'yleinen.sulje': 'Sulje',
  'yleinen.muokkaa': 'Muokkaa',
  'yleinen.poista': 'Poista',
  'yleinen.valitse': 'Valitse…',
  'yleinen.valinnainen': '(valinnainen)',
  'yleinen.eiOsumia': 'Ei osumia.',
  'yleinen.eiKirjauksia': 'Ei kirjauksia.',
  'yleinen.tallennusEpaonnistui': 'Tallennus epäonnistui.',
  'yleinen.yhteysEpaonnistui': 'Yhteys palvelimeen epäonnistui. Yritä uudelleen.',
  'yleinen.koodi': 'Koodi',
  'yleinen.nimi': 'Nimi',
  'yleinen.tila': 'Tila',
  'yleinen.rooli': 'Rooli',
  'yleinen.sahkoposti': 'Sähköposti',
  'yleinen.asiakas': 'Asiakas',
  'yleinen.tunnit': 'Tunnit',
  'yleinen.kirjauksia': 'Kirjauksia',
  'yleinen.laskutettava': 'Laskutettava',
  'yleinen.eiLaskuteta': 'Ei laskuteta',
  'yleinen.eiHintaa': 'ei hintaa',
  'yleinen.aktiivinen': 'Aktiivinen',
  'yleinen.perustelu': 'Perustelu',
  'yleinen.kylla': 'kyllä',
  'yleinen.ei': 'ei',
  'yleinen.sisallytaSisainen': 'Sisällytä sisäinen työ',
  'yleinen.sisainenSelite': '— lomat, poissaolot ja sisäinen kehitys',
  'yleinen.vieCsv': 'Vie CSV',
  'yleinen.vieJson': 'Vie JSON',
  'yleinen.vieExcel': 'Vie Excel',

  // --- Roolit -------------------------------------------------------------
  'rooli.ADMIN': 'Ylläpitäjä',
  'rooli.USER': 'Käyttäjä',
  'rooli.ACCOUNT_MANAGER': 'Asiakasvastaava',
  'rooli.REPORTER': 'Raportoija',

  // --- Kehys ja navigaatio -------------------------------------------------
  'sovellus.nimi': 'Devikone Platform',
  'navi.paanavigaatio': 'Päänavigaatio',
  'navi.kalenteri': 'Kalenteri',
  'navi.omatTunnit': 'Omat tunnit',
  'navi.raportit': 'Raportit',
  'navi.vienti': 'Vienti',
  'navi.taulut': 'Taulut',
  'navi.hallinta': 'Hallinta',
  'navi.kuukaudet': 'Kuukaudet',
  'navi.agentti': 'Agentti ja MCP',
  'navi.ulkoasu': 'Ulkoasu',
  'navi.kirjauduUlos': 'Kirjaudu ulos',
  'kehys.vastuuasiakkaasi': 'Vastuuasiakkaasi',
  'kehys.vastuuasiakkaatSelite':
    'Raporttien luvut ovat näiden asiakkaiden summa, eivät koko talon.',

  // --- Kirjautuminen ------------------------------------------------------
  'kirjautuminen.iskulause': 'Jokainen tunti oikealle asiakkaalle',
  'kirjautuminen.kuvaus':
    'Tuntikirjanpito, projektit, koulutukset ja osaaminen samassa järjestelmässä.',
  'kirjautuminen.microsoft': 'Kirjaudu Microsoft-tilillä',
  'kirjautuminen.ohje':
    'Kirjautuminen käyttää Devikoneen Microsoft-tunnuksia. Jos et pääse sisään, ota yhteyttä ylläpitoon.',
  'kirjautuminen.virheKeskeytyi': 'Kirjautuminen keskeytyi. Yritä uudelleen.',
  'kirjautuminen.virheVanhentui':
    'Kirjautuminen vanheni matkalla. Aloita uudelleen — tämä tapahtuu, jos välilehti oli auki pitkään.',
  'kirjautuminen.virheEpaonnistui':
    'Kirjautuminen ei onnistunut. Jos ongelma toistuu, ota yhteyttä ylläpitoon.',
  'kirjautuminen.virheIstuntoPaattyi': 'Istuntosi on päättynyt. Kirjaudu uudelleen jatkaaksesi.',
  'kirjautuminen.virheYleinen': 'Kirjautuminen ei onnistunut.',
  'kirjautuminen.salasanaOtsikko': 'Kirjaudu salasanalla',
  'kirjautuminen.salasana': 'Salasana',
  'kirjautuminen.kirjaudu': 'Kirjaudu',
  'kirjautuminen.kirjaudutaan': 'Kirjaudutaan…',
  'kirjautuminen.taiMicrosoft': 'tai',
  'kirjautuminen.paikallinenOhje':
    'Paikallinen tili on ylläpitäjän luoma. Sama tili liittyy Microsoft-tiliisi itsestään, kun kirjaudut ensimmäisen kerran Microsoftilla samalla sähköpostilla.',
  'kehityskirjautuminen.otsikko': 'Kehityskirjautuminen',
  'kehityskirjautuminen.selite': 'Ohittaa Entra ID:n. Näkyy vain kehityspalvelimella.',
  'kehityskirjautuminen.kirjaudu': 'Kirjaudu kehitystunnuksilla',
  'kehityskirjautuminen.kirjaudutaan': 'Kirjaudutaan…',
  'kehityskirjautuminen.virhe': 'Kehityskirjautuminen ei onnistunut.',

  // --- Salasana -----------------------------------------------------------
  'salasana.vaihda': 'Vaihda salasana',
  'salasana.nykyinen': 'Nykyinen salasana',
  'salasana.uusi': 'Uusi salasana',
  'salasana.uusiUudelleen': 'Uusi salasana uudelleen',
  'salasana.eiTasmaa': 'Salasanat eivät täsmää.',
  'salasana.vaatimus': 'Vähintään 12 merkkiä.',
  'salasana.vaihdettu': 'Salasana vaihdettu. Muut istunnot on kirjattu ulos.',
  'salasana.pakkoOtsikko': 'Vaihda salasana jatkaaksesi',
  'salasana.pakkoSelite':
    'Tilillesi on asetettu väliaikainen salasana. Vaihda se omaan salasanaasi ennen kuin jatkat.',

  // --- Sivua ei löytynyt --------------------------------------------------
  'eiLoytynyt.otsikko': 'Sivua ei löytynyt',
  'eiLoytynyt.selite': 'Osoite ei vastaa mitään näkymää. Tarkista linkki tai palaa kalenteriin.',
  'eiLoytynyt.linkki': 'Takaisin kalenteriin',

  // --- Asiakasvalitsin ----------------------------------------------------
  'asiakasValitsin.hae': 'Hae asiakasta koodilla tai nimellä…',
  'asiakasValitsin.vaihda': 'Vaihda',
  'asiakasValitsin.vastuullasi': 'vastuullasi',

  // --- Kestovalitsin ------------------------------------------------------
  'kesto.vahenna': 'Vähennä puoli tuntia',
  'kesto.lisaa': 'Lisää puoli tuntia',

  // --- Jaksovalitsin ------------------------------------------------------
  'jakso.kuukausi': 'Kuukausi',
  'jakso.edellinenKuukausi': 'Edellinen kuukausi',
  'jakso.seuraavaKuukausi': 'Seuraava kuukausi',
  'jakso.tamaKk': 'Tämä kk',
  'jakso.aikavali': 'Aikaväli',
  'jakso.alkupaiva': 'Alkupäivä',
  'jakso.loppupaiva': 'Loppupäivä',
  'jakso.kuluvaKk': 'Kuluva kk',
  'jakso.edellinenKk': 'Edellinen kk',
  'jakso.kuluvaNeljannes': 'Kuluva neljännes',
  'jakso.vuosi': 'Vuosi',

  // --- Budjettitila -------------------------------------------------------
  'budjetti.HOURS_NEAR_BUDGET': 'Tuntibudjetti lähes käytetty',
  'budjetti.VALUE_NEAR_BUDGET': 'Eurobudjetti lähes käytetty',
  'budjetti.HOURS_OVER_BUDGET': 'Tuntibudjetti ylitetty',
  'budjetti.VALUE_OVER_BUDGET': 'Eurobudjetti ylitetty',
  'budjetti.HOURS_AHEAD_OF_SCHEDULE': 'Tunnit kuluvat aikataulua nopeammin',
  'budjetti.VALUE_AHEAD_OF_SCHEDULE': 'Eurot kuluvat aikataulua nopeammin',
  'budjetti.SCHEDULE_ENDED': 'Aikataulu on päättynyt, projekti yhä käynnissä',
  'budjetti.ylitysTiivis': 'Ylitys',
  'budjetti.ylitys': 'Budjetti ylitetty',
  'budjetti.varoitus': 'Varoitus',
  'budjetti.aikataulussa': 'Aikataulussa',

  // --- Kirjauslomake ------------------------------------------------------
  'kirjaus.uusi': 'Uusi kirjaus',
  'kirjaus.muokkaa': 'Muokkaa kirjausta',
  'kirjaus.viimeksiKaytetyt': 'Viimeksi käytetyt',
  'kirjaus.paiva': 'Päivä',
  'kirjaus.tehtavalaji': 'Tehtävälaji',
  'kirjaus.valitseEnsinAsiakas': 'Valitse ensin asiakas',
  'kirjaus.eiLaskuteta': ' (ei laskuteta)',
  'kirjaus.projekti': 'Projekti',
  'kirjaus.eiProjektia': 'Ei projektia',
  'kirjaus.kesto': 'Kesto',
  'kirjaus.sisainenEiLaskuteta': ' — sisäistä työtä ei laskuteta',
  'kirjaus.kuvaus': 'Kuvaus',
  'kirjaus.tehtava': 'Tehtävä',
  'kirjaus.poistaTehtavaviite': 'Poista viittaus tehtävään',
  'kirjaus.tallennaJaJatka': 'Tallenna ja +',
  'kirjaus.valitseAsiakasJaTehtavalaji': 'Valitse asiakas ja tehtävälaji.',
  'kirjaus.tallennettu': 'Kirjaus tallennettu.',
  'kirjaus.budjetti': (budjetti: string) => `Budjetti ${budjetti}`,
  'kirjaus.budjettiHtp': (htp: string) => ` (${htp})`,
  'kirjaus.kaytetty': (kaytetty: string, osuus: string) => `käytetty ${kaytetty} · ${osuus}`,

  // --- Kirjauksen tiedot --------------------------------------------------
  'tiedot.otsikko': 'Kirjaus',
  'tiedot.paiva': 'Päivä',
  'tiedot.kirjaaja': 'Kirjaaja',
  'tiedot.eiKuvausta': 'Ei kuvausta.',
  'tiedot.kirjattu': 'Kirjattu',
  'tiedot.muokattu': 'Muokattu',
  'tiedot.lukittu': 'Kuukausi on lukittu, joten kirjausta ei voi enää muuttaa.',

  // --- Kalenteri ----------------------------------------------------------
  'kalenteri.viikko': 'Viikko',
  'kalenteri.kuukausi': 'Kuukausi',
  'kalenteri.viikkoNumero': (numero: number) => `Viikko ${numero}`,
  'kalenteri.edellinenViikko': 'Edellinen viikko',
  'kalenteri.seuraavaViikko': 'Seuraava viikko',
  'kalenteri.edellinenKuukausi': 'Edellinen kuukausi',
  'kalenteri.seuraavaKuukausi': 'Seuraava kuukausi',
  'kalenteri.tanaan': 'Tänään',
  'kalenteri.viikonTunnit': 'Viikon tunnit',
  'kalenteri.kuukaudenTunnit': 'Kuukauden tunnit',
  'kalenteri.tayttoaste': (prosenttia: number) => `Täyttöaste ${prosenttia} prosenttia`,
  'kalenteri.lukittu': (kuukaudet: string) => `Lukittu: ${kuukaudet}`,
  'kalenteri.kopioitu': (maara: number) =>
    maara === 1 ? 'Kopioitu 1 kirjaus.' : `Kopioitu ${maara} kirjausta.`,
  'kalenteri.kopiointiEpaonnistui': 'Kopiointi epäonnistui.',
  'kalenteri.poistetaanko': 'Poistetaanko kirjaus?',
  'kalenteri.vk': 'Vk',
  'kalenteri.yhteensa': 'Yht.',
  'kalenteri.muuta': (maara: number) => `+${maara} muuta`,
  'kalenteri.eiKirjauksia': 'Ei kirjauksia',
  'kalenteri.siirretty': (pvm: string) => `Kirjaus siirretty päivälle ${pvm}.`,
  'kalenteri.siirtoEpaonnistui': 'Siirto epäonnistui.',
  'kalenteri.kopioiEdellinen': 'Kopioi edellinen päivä',
  'kalenteri.kuukausiLukittu': 'Kuukausi on lukittu.',
  'kalenteri.lisaaKirjaus': (paiva: string) => `Lisää kirjaus päivälle ${paiva}`,
  'kalenteri.avaaKirjaus': 'Näytä kirjauksen tiedot',
  'kalenteri.avaaEhdotus': (asiakas: string) => `Käsittele koneen ehdotus: ${asiakas}`,
  'kalenteri.vahvistaEhdotus': 'Ehdotus — vahvista',
  'kalenteri.ehdotuksia': (maara: number) => (maara === 1 ? '1 ehdotus' : `${maara} ehdotusta`),
  'kalenteri.monistaKirjaus': 'Monista kirjaus samalle päivälle',
  'kalenteri.monistettu': (pvm: string) => `Kirjaus monistettu päivälle ${pvm}.`,
  'kalenteri.monistusEpaonnistui': 'Monistus epäonnistui.',
  'kalenteri.muokkaaKirjausta': 'Muokkaa kirjausta',
  'kalenteri.poistaKirjaus': 'Poista kirjaus',
  'kalenteri.ohjeAlku':
    'Selaa nuolinäppäimillä ← ja →, palaa tähän päivään näppäimellä T, vaihda näkymää näppäimillä V ja K, lisää kirjaus valitulle päivälle näppäimellä N. Merkki',
  'kalenteri.ohjeLoppu':
    'tarkoittaa, ettei kirjausta laskuteta. Kirjauksen klikkaus avaa sen tiedot. Raahaus siirtää kirjauksen toiselle päivälle; Ctrl, Alt tai Cmd pohjassa raahattu kirjaus monistuu siirtymisen sijaan.',
  'kalenteri.ohjeKuukausi':
    ' Kuukausinäkymä on tarkistusnäkymä — päivän klikkaus vie viikkonäkymään.',

  // --- Omat tunnit --------------------------------------------------------
  'omatTunnit.otsikko': 'Omat tunnit',
  'omatTunnit.kirjatutTunnit': 'Kirjatut tunnit',
  'omatTunnit.odotus': 'Odotus',
  'omatTunnit.odotusSelite': 'arkipäivät × viikkotunnit / 5',
  'omatTunnit.tayttoaste': 'Täyttöaste',
  'omatTunnit.tayttoasteSelite': 'onko kirjaukset tehty',
  'omatTunnit.laskutettavienOsuus': 'Laskutettavien osuus',
  'omatTunnit.laskutettavienSelite': 'mihin aika menee',
  'omatTunnit.asiakkaittain': 'Asiakkaittain',
  'omatTunnit.tehtavalajeittain': 'Tehtävälajeittain',
  'omatTunnit.alaviite':
    'Odotusluku ei ota huomioon pyhäpäiviä eikä lomia, joten vajaa täyttöaste lomakuukautena on odotettavaa. Luku on oma seurantasi, ei tavoite jota vasten mitataan.',

  // --- Raportit -----------------------------------------------------------
  'raportit.otsikko': 'Raportit',
  'raportit.naetVastuuasiakkaasi': 'Näet vastuuasiakkaasi',
  'raportit.vastuuasiakkaatSelite': 'Luvut ovat näiden asiakkaiden summa, eivät koko talon.',
  'raportit.laskutettavatTunnit': 'Laskutettavat tunnit',
  'raportit.laskutus': 'Laskutus',
  'raportit.kirjatutTunnit': 'Kirjatut tunnit',
  'raportit.laskutusaste': 'Laskutusaste',
  'raportit.kirjatut': 'Kirjatut',
  'raportit.laskutettavat': 'Laskutettavat',
  'raportit.osuus': 'Osuus',
  'raportit.tarkistettuLyhenne': 'Tark.',
  'raportit.eiKirjauksiaJaksolla': 'Ei kirjauksia tällä jaksolla.',
  'raportit.yhteensaAsiakkaat': (maara: number) =>
    maara === 1 ? 'Yhteensä (1 asiakas)' : `Yhteensä (${maara} asiakasta)`,
  'raportit.kuukausiLukittu': 'Kuukausi lukittu',
  'raportit.kuukausiAvoin': 'Kuukausi avoin — luvut voivat vielä muuttua',
  'raportit.kuukausiaLukittu': (lukitut: number, kaikki: number) =>
    `${lukitut}/${kaikki} kuukautta lukittu`,
  'raportit.tarkistettu': 'Tarkistettu',
  'raportit.muuttunut': 'Muuttunut',
  'raportit.tarkistamatta': 'Tarkistamatta',
  'raportit.tarkistettuOtsikko': (aika: string, kuka: string, muuttunut: boolean) =>
    `Tarkistettu ${aika}${kuka ? ` (${kuka})` : ''}${
      muuttunut ? ' — kirjauksia muutettu sen jälkeen' : ''
    }`,

  // --- Asiakkaan raportti -------------------------------------------------
  'raporttiAsiakas.tyontekija': 'Työntekijä',
  'raporttiAsiakas.tehtavalaji': 'Tehtävälaji',
  'raporttiAsiakas.projekti': 'Projekti',
  'raporttiAsiakas.summa': (kirjatut: string, laskutettavat: string) =>
    `Kirjatut ${kirjatut} · Laskutettavat ${laskutettavat}`,
  'raporttiAsiakas.summaLaskutus': (arvo: string) => ` · Laskutus ${arvo}`,
  'raporttiAsiakas.vieAsiakas': 'Vie tämä asiakas',
  'raporttiAsiakas.vientiOtsikko': 'Vie asiakkaan tunnit',
  'raporttiAsiakas.vientiSelite':
    'Excel ryhmitellään kuten raportti: jokainen ryhmä alkaa omalla värillään korostetulla väliotsikolla ja päättyy välisummaan. CSV on tasainen lista jatkokäsittelyä varten.',
  'raporttiAsiakas.sarakkeet': 'Sarakkeet',
  'raporttiAsiakas.ryhmittely': 'Ryhmittely:',
  'raporttiAsiakas.pvm': 'Pvm',
  'raporttiAsiakas.arvo': 'Arvo',
  'raporttiAsiakas.tarkistaUudelleen': 'Tarkista uudelleen',
  'raporttiAsiakas.merkitseTarkistetuksi': 'Merkitse tarkistetuksi',
  'raporttiAsiakas.peruKuittaus': 'Peru kuittaus',
  'raporttiAsiakas.kuittausEpaonnistui': 'Kuittaus epäonnistui.',

  // --- Vienti -------------------------------------------------------------
  'vienti.otsikko': 'Vienti',
  'vienti.asiakasvastaavaHuomio':
    'Vienti sisältää vain vastuuasiakkaidesi rivit, ja tiedosto on merkitty rajatuksi sekä nimessä että metatiedoissa.',
  'vienti.jakso': 'Jakso',
  'vienti.kuukausi': 'Kuukausi',
  'vienti.tamaKuukausi': 'Tämä kuukausi',
  'vienti.vapaaAikavali': 'Vapaa aikaväli',
  'vienti.asiakasRajaus': '(valinnainen rajaus)',
  'vienti.poistaRajaus': 'Poista rajaus',
  'vienti.vainLaskutettavat': 'Vain laskutettavat rivit',
  'vienti.csvMurre': 'CSV-murre',
  'vienti.murreExcel': 'Excel (suomalainen) — puolipiste, desimaalipilkku, BOM',
  'vienti.murreRfc': 'RFC 4180 — pilkku, desimaalipiste, ei BOM:ia',
  'vienti.murreSelite':
    'Suomenkielinen Excel avaa oletusmurteen suoraan sarakkeisiin. Valitse RFC 4180, jos tiedosto luetaan koneellisesti.',
  'vienti.jarjestysVirhe': 'Alkupäivä ei voi olla loppupäivän jälkeen.',
  'vienti.alaviite':
    'Vienti ei edellytä lukitusta — jakson voi viedä tarkistettavaksi milloin tahansa. JSON kertoo metatiedoissaan jokaisen kuukauden lukitustilan, jotta vastaanottaja tietää, voiko aineisto vielä muuttua. Poistetut kirjaukset eivät sisälly.',

  // --- Hallinnan kehys ----------------------------------------------------
  'hallinta.osiot': 'Hallinnan osiot',
  'hallinta.asiakkaat': 'Asiakkaat',
  'hallinta.projektit': 'Projektit',
  'hallinta.hinnasto': 'Hinnasto',
  'hallinta.kayttajat': 'Käyttäjät',
  'hallinta.muutosloki': 'Muutosloki',
  'hallinta.koulutukset': 'Koulutukset',
  'hallinta.koulutustilanne': 'Koulutustilanne',
  'hallinta.kuukaudet': 'Kuukaudet',
  'hallinta.asetukset': 'Asetukset',
  'hallinta.attribuutit': 'Attribuutit',

  // --- Asiakkaat ----------------------------------------------------------
  'asiakkaat.hae': 'Hae koodilla tai nimellä…',
  'asiakkaat.naytaPassivoidut': 'Näytä passivoidut',
  'asiakkaat.uusi': 'Uusi asiakas',
  'asiakkaat.oletustuntihinta': 'Oletustuntihinta',
  'asiakkaat.projektit': 'Projektit',
  'asiakkaat.avaaProjektit': (nimi: string) => `Avaa asiakkaan ${nimi} projektit`,
  'asiakkaat.sisainen': 'sisäinen',
  'asiakkaat.passivoitu': 'Passivoitu',
  'asiakkaat.oletustuntihintaKentta': (merkki: string) => `Oletustuntihinta ${merkki}/h`,
  'asiakkaat.oletustuntihintaSelite':
    'Tehtävälajit perivät tämän, jos niille ei anneta omaa hintaa.',
  'asiakkaat.luoTehtavalajit': 'Luo oletustehtävälajit',
  'asiakkaat.luoTehtavalajitSelite': 'Ilman tehtävälajeja asiakkaalle ei voi kirjata tunteja.',

  // --- Tehtävälajipohjan levitys ------------------------------------------
  'pohja.otsikko': 'Oletustehtävälajipohja',
  'pohja.selite':
    'Pohja kopioidaan asiakkaalle kerran, asiakasta luotaessa. Pohjaan myöhemmin lisätty tehtävälaji ei siis ilmesty jo perustetuille asiakkaille itsestään — se lisätään tästä.',
  'pohja.ajanTasalla': 'Kaikilla asiakkailla on pohjan tehtävälajit.',
  'pohja.puuttuuMonelta': (asiakkaita: number) =>
    asiakkaita === 1
      ? 'Yhdeltä asiakkaalta puuttuu pohjan tehtävälajeja.'
      : `${asiakkaita} asiakkaalta puuttuu pohjan tehtävälajeja.`,
  'pohja.valitseKaikki': 'Valitse kaikki',
  'pohja.tyhjennaValinta': 'Tyhjennä valinta',
  'pohja.lisaaValituille': (montako: number) => `Lisää valituille (${montako})`,
  'pohja.lisataan': 'Lisätään…',
  'pohja.lisatty': (tehtavalajeja: number, asiakkaita: number) =>
    `Lisättiin ${tehtavalajeja} tehtävälajia ${asiakkaita} asiakkaalle.`,
  'pohja.eiMuutaVanhoja':
    'Lisäys ei muuta olemassa olevia tehtävälajeja, nimiä eikä hintoja. Sisäinen asiakas jää aina ulkopuolelle.',
  'pohja.epaonnistui': 'Tehtävälajien lisäys epäonnistui.',

  // --- Huomautukset (backlog 3.5) -----------------------------------------
  'huomautus.otsikko': 'Huomautukset kirjauksistasi',
  'huomautus.selite':
    'Asiakasvastaava on huomauttanut näistä kirjauksista. Korjaus on sinun: huomautus ei muuta kirjausta eikä estä mitään.',
  'huomautus.kuittaa': 'Kuittaa käsitellyksi',
  'huomautus.kuitattu': 'Kuitattu',
  'huomautus.peruKuittaus': 'Peru kuittaus',
  'huomautus.avaaPaiva': 'Avaa päivä',
  'huomautus.kirjoita': 'Huomauta kirjauksesta',
  'huomautus.dialogiOtsikko': 'Huomautus kirjauksesta',
  'huomautus.teksti': 'Mikä kirjauksessa on korjattavaa?',
  'huomautus.vihje':
    'Viesti menee kirjauksen tekijälle sähköpostina. Huomautus ei muuta kirjausta eikä estä lukitusta — korjauksen tekee tekijä.',
  'huomautus.laheta': 'Lähetä huomautus',
  'huomautus.lahetetaan': 'Lähetetään…',
  'huomautus.lahetetty': 'Huomautus tallennettiin ja lähetettiin sähköpostina.',
  'huomautus.lahetettyEiPostia': 'Huomautus tallennettiin. Sähköpostia ei lähetetty.',
  'huomautus.epaonnistui': 'Huomautuksen tallennus epäonnistui.',
  'huomautus.poista': 'Poista huomautus',
  'huomautus.merkki': (montako: number) =>
    montako === 1 ? 'Yksi avoin huomautus' : `${montako} avointa huomautusta`,
  'huomautus.eiAvoimia': 'Ei avoimia huomautuksia.',

  // --- Muistutusten asetukset ---------------------------------------------
  'muistutukset.otsikko': 'Muistutukset',
  'muistutukset.selite':
    'Sähköpostimuistutukset lähtevät palvelimen ajastimen mukaan kerran aamussa. Tässä valitaan, mitkä muistutukset ovat käytössä ja minä päivinä ne lähtevät — kellonaika tulee palvelimen ajastimesta.',
  'muistutukset.eiPostia':
    'Sähköpostia ei ole määritetty palvelimella (MAILTRAP_API_TOKEN ja MAIL_FROM). Muistutukset eivät lähde, vaikka ne olisivat tässä käytössä.',
  'muistutukset.kaytossa': 'Käytössä',
  'muistutukset.eiKaytossa': 'Ei käytössä',
  'muistutukset.viikonpaiva': 'Lähetyspäivä',
  'muistutukset.ikkuna': 'Lähetetään kuukauden päivinä',
  'muistutukset.ikkunaAlku': 'Aikaisintaan',
  'muistutukset.ikkunaLoppu': 'Viimeistään',
  'muistutukset.ikkunaSelite':
    'Ensimmäinen ajo tällä välillä lähettää viestin. Väli eikä yksi päivä siksi, että väliin jäänyt ajo — esimerkiksi sammutettu palvelin — ei jättäisi muistutusta kokonaan lähettämättä.',
  'muistutukset.lisateksti': 'Talon oma lisäys viestiin',
  'muistutukset.lisatekstiSelite':
    'Näkyy viestin lopussa ennen allekirjoitusta. Viestin runko ei ole muokattavissa: se sisältää laskettua tietoa, kuten viikkonumeron ja tarkistamattomat asiakkaat.',
  'muistutukset.esikatsele': 'Esikatsele viesti',
  'muistutukset.piilotaEsikatselu': 'Piilota esikatselu',
  'muistutukset.esikatseluHuomio':
    'Esikatselun luvut ja nimet ovat esimerkkejä, eivät oikeaa dataa. Tallentamattomat muutokset eivät näy esikatselussa.',
  'muistutukset.laheta': 'Lähetä testiviesti itselleni',
  'muistutukset.lahetetaan': 'Lähetetään…',
  'muistutukset.lahetetty': (osoite: string) => `Testiviesti lähetettiin osoitteeseen ${osoite}.`,
  'muistutukset.tallenna': 'Tallenna muistutukset',
  'muistutukset.tallennettu': 'Muistutukset tallennettu.',
  'muistutukset.WEEKLY_ENTRIES_MISSING': 'Viikon tunnit ovat kirjaamatta',
  'muistutukset.WEEKLY_ENTRIES_MISSINGSelite':
    'Lähtee jokaiselle, joka kirjaa tunteja, jos kuluvalta viikolta ei ole yhtään kirjausta.',
  'muistutukset.MONTH_UNCHECKED_CUSTOMERS': 'Asiakkaita on tarkistamatta',
  'muistutukset.MONTH_UNCHECKED_CUSTOMERSSelite':
    'Lähtee asiakasvastaavalle, jonka vastuuasiakkaalla on edellisen kuukauden tunteja kuittaamatta.',
  'muistutukset.MONTH_NOT_LOCKED': 'Kuukausi on lukitsematta',
  'muistutukset.MONTH_NOT_LOCKEDSelite':
    'Lähtee ylläpitäjille, jos edellinen kuukausi on yhä auki ja siinä on kirjauksia.',
  'muistutukset.TRAINING_OVERDUE': 'Pakollisia koulutuksia on käymättä',
  'muistutukset.TRAINING_OVERDUESelite':
    'Lähtee jokaiselle, jolta puuttuu pakollinen koulutus tai jonka suoritus on vanhentumassa (docs/KOULUTUKSET.md).',
  'muistutukset.TASK_BLOCKED_OVERDUE': 'Tehtävä on jumissa yli rajan',
  'muistutukset.TASK_BLOCKED_OVERDUESelite':
    'Lähtee tehtävän luojalle ja asiakasvastaavalle, kun tehtävä on ollut BLOCKED-osiossa yli kahdeksan päivää, ja sen jälkeen viikoittain.',
  'muistutukset.MILESTONE_DUE': 'Milestone erääntyy tai on myöhässä',
  'muistutukset.MILESTONE_DUESelite':
    'Lähtee milestonen luojalle ja asiakasvastaavalle kolme päivää ennen saavuttamattoman milestonen eräpäivää ja viikoittain, kun se on myöhässä.',
  'muistutukset.DEVELOPMENT_REVIEW_DUE': 'Kehityskeskusteluja on erääntynyt',
  'muistutukset.DEVELOPMENT_REVIEW_DUESelite':
    'Lähtee esihenkilölle kuun alussa, kun alaisen kehityskeskustelu on erääntynyt (docs/KEHITYSSUUNNITELMAT.md).',
  'muistutukset.CERTIFICATION_EXPIRING': 'Sertifikaatti vanhenee',
  'muistutukset.CERTIFICATION_EXPIRINGSelite':
    'Lähtee työntekijälle kuun alussa, kun hänen sertifikaattinsa vanhenee 90 päivän kuluessa.',
  'muistutukset.arkipaivisinSelite':
    'Ajopäivä ei ole asetus: viesti lähtee sinä arkipäivänä, jona tehtävä ylittää rajan, ja viikonloppuun osuva päivä siirtyy maanantaihin.',
  'muistutukset.arkipaivisinMilestoneSelite':
    'Ajopäivä ei ole asetus: ennakkoviesti lähtee kolme päivää ennen eräpäivää, ja viikonloppuun osuva päivä aikaistuu perjantaihin. Myöhästymisviesti lähtee eräpäivän jälkeisenä arkipäivänä ja sitten viikoittain.',
  'muistutukset.jarjestysVihje':
    'Tarkistusmuistutus kannattaa ajoittaa ennen lukitusmuistutusta: asiakasvastaava tarkistaa, ylläpitäjä lukitsee.',

  // --- Työntekijäerittely (12.6) -------------------------------------------
  'tyontekijat.otsikko': 'Työntekijäkohtainen erittely',
  'tyontekijat.tyontekija': 'Työntekijä',
  'tyontekijat.osuus': 'Osuus kirjatuista',
  'tyontekijat.odotettu': 'Odotettu',
  'tyontekijat.laskutusaste': 'Laskutusaste',
  'tyontekijat.kulunut': (alkaen: string, asti: string, arkipaivia: number) =>
    `Luvut ajalta ${alkaen}–${asti}: ${arkipaivia} arkipäivää kulunut.`,
  'tyontekijat.tavoiteSelite': (tavoite: string) => `Tavoite ${tavoite}, ellei omaa ole asetettu.`,
  'tyontekijat.tavoite': (tavoite: string) => `tavoite ${tavoite}`,
  'tyontekijat.alleTavoitteen': (tavoite: string) => `Alle tavoitteen ${tavoite}`,
  'tyontekijat.poissa': (tunnit: string) => `poissa ${tunnit}`,
  'tyontekijat.eiTyontekijoita': 'Ei työntekijöitä, joilta tunteja odotetaan.',
  'tyontekijat.mihinAikaMeni': 'Mihin aika meni',
  'tyontekijat.avaaErittely': (nimi: string) => `Näytä asiakkaat ja projektit: ${nimi}`,
  'tyontekijat.porautumisSelite':
    'Samat luvut kuin rivillä: kulunut jakso ja sisäinen työ mukana. Asiakkaan nimestä pääsee asiakaskohtaiseen erittelyyn.',
  'tyontekijat.eiProjektia': 'Ei projektia',
  'tyontekijat.eiKirjauksia': 'Ei kirjauksia kuluneella jaksolla.',
  'tyontekijat.avaaAsiakas': (nimi: string) => `Asiakaskohtainen erittely: ${nimi}`,
  'tyontekijat.alaviite':
    'Laskutusaste on laskutettavat tunnit jaettuna kuluneella työajalla — se ei siis parane kirjaamalla vähemmän. Osuus kirjatuista kertoo, mihin kirjattu aika meni. Loma ja sairaus pienentävät odotettua työaikaa. Sisäinen työ on aina mukana kirjatuissa tunneissa, myös silloin kun se on suodatettu asiakastaulukosta.',

  // --- Laskutustavoite (12.6) ----------------------------------------------
  'tavoite.otsikko': 'Laskutettavan työn tavoite',
  'tavoite.selite':
    'Tavoite on osuus kuluneesta työajasta, joka menee laskutettavaan työhön. Se näkyy vain ylläpitäjille, raportin työntekijäerittelyssä. Yksittäiselle työntekijälle voi asettaa oman tavoitteen käyttäjäkortilta.',
  'tavoite.kentta': 'Oletustavoite',
  'tavoite.kayttajaKentta': 'Oma laskutustavoite',
  'tavoite.kayttajaSelite': (oletus: string) =>
    `Tyhjä = järjestelmän oletus (${oletus}). Näkyy vain ylläpitäjille.`,
  'tavoite.tallenna': 'Tallenna tavoite',
  'tavoite.tallennettu': 'Tavoite tallennettu.',
  'tavoite.virheellinen': 'Tavoitteen on oltava välillä 0–100 %.',

  // --- Asiakaskortti ------------------------------------------------------
  'asiakas.hinnanMuutosVahvistus':
    'Hinnan muutos koskee vain uusia kirjauksia. Jo kirjatut tunnit säilyttävät sen hinnan, jolla ne kirjattiin.\n\nJatketaanko?',
  'asiakas.eiLoytynyt': 'Asiakasta ei löytynyt.',
  'asiakas.sisainenSelite': 'sisäinen asiakas — ei laskutusta eikä asiakasvastaavia',
  'asiakas.savy': 'Sävy kalenterissa',
  'asiakas.savySelite':
    'Sävy kertoo kalenterissa, kenelle työ on tehty. Ilman valintaa se johdetaan asiakaskoodista, jolloin jokainen asiakas saa värin ilman ylläpitoa. Valitse sävy vain, kun kaksi asiakasta osuu samaan ja se häiritsee.',
  'asiakas.savyJohdettu': 'Johdettu koodista',
  'asiakas.savyJohdettuSelite': 'Ei valintaa — sävy seuraa asiakaskoodia.',
  'asiakas.savyKaytossa': (asiakkaat: string) => `Myös: ${asiakkaat}`,
  'asiakas.savyVapaa': 'Ei muita tässä sävyssä.',
  'asiakas.savyMuita': (maara: number) => `ja ${maara} muuta`,
  'asiakas.savyValittu': 'Valittu sävy',
  'savy.punainen': 'Punainen',
  'savy.oranssi': 'Oranssi',
  'savy.kulta': 'Kulta',
  'savy.vihrea': 'Vihreä',
  'savy.smaragdi': 'Smaragdi',
  'savy.turkoosi': 'Turkoosi',
  'savy.taivas': 'Taivas',
  'savy.violetti': 'Violetti',
  'savy.purppura': 'Purppura',
  'savy.pinkki': 'Pinkki',
  'asiakas.perustiedot': 'Perustiedot',
  'asiakas.aktiivinenSelite': ' — passivoidulle ei voi kirjata tunteja',
  'asiakas.asiakasvastaavat': 'Asiakasvastaavat',
  'asiakas.eiAsiakasvastaavaa':
    'Ei asiakasvastaavaa. Kuun vaihteessa kukaan ei tarkista tämän asiakkaan tunteja.',
  'asiakas.asiakasvastaavaSelite':
    'Asiakasvastaava näkee tämän asiakkaan kaikki tuntikirjaukset ja rahamäärät.',
  'asiakas.tehtavalajit': 'Tehtävälajit',
  'asiakas.uusiTehtavalaji': 'Uusi tehtävälaji',
  'asiakas.tehtavalajiOtsikko': (nimi: string) => `Tehtävälaji · ${nimi}`,
  'asiakas.tuntihinta': 'Tuntihinta',
  'asiakas.poistettuKaytosta': 'poistettu käytöstä',
  'asiakas.asiakkaanOletus': '(asiakkaan oletus)',
  'asiakas.laskutettavaOletuksena': 'Laskutettava oletuksena',
  'asiakas.tuntihintaKentta': (merkki: string) => `Tuntihinta ${merkki}/h`,
  'asiakas.periAsiakkaalta': '(tyhjä = peri asiakkaalta)',
  'asiakas.kaytossa': 'Käytössä',

  // --- Projektit ----------------------------------------------------------
  'projektit.PLANNED': 'Suunniteltu',
  'projektit.ACTIVE': 'Käynnissä',
  'projektit.CLOSED': 'Päättynyt',
  'projektit.uusi': 'Uusi projekti',
  'projektit.eiSisaiselle': 'Sisäiselle asiakkaalle ei perusteta projekteja.',
  'projektit.valitseAsiakas': 'Valitse asiakas nähdäksesi sen projektit.',
  'projektit.aikataulu': 'Aikataulu',
  'projektit.budjetti': 'Budjetti',
  'projektit.kaytetty': 'Käytetty',
  'projektit.eiProjekteja': 'Ei projekteja.',
  'projektit.ajasta': (osuus: string) => ` / ${osuus} ajasta`,
  'projektit.otsikko': (nimi: string) => `Projekti · ${nimi}`,
  'projektit.uusiOtsikko': (asiakas: string) => `Uusi projekti · ${asiakas}`,
  'projektit.alkaa': 'Alkaa',
  'projektit.paattyy': 'Päättyy',
  'projektit.tuntihinta': (merkki: string) => `Tuntihinta ${merkki}/h`,
  'projektit.tuntihintaSelite':
    'Ohittaa tehtävälajien ja asiakkaan hinnat. Tyhjänä hinta tulee tehtävälajilta.',
  'projektit.periTehtavalajilta': 'peri tehtävälajilta',
  'projektit.kokonaisbudjetti': 'Kokonaisbudjetti',
  'projektit.arvo': 'Arvo',
  'projektit.htpVihje': (htp: string, kerroin: string) => `= ${htp} htp (${kerroin} h/htp)`,
  'projektit.arvoVihje': (tunnit: string, hinta: string, merkki: string, summa: string) =>
    `Vihje: ${tunnit} h × ${hinta} ${merkki}/h = ${summa}`,
  'projektit.htpMuunnos': 'Htp-muunnos h/htp',
  'projektit.htpMuunnosSelite': (oletus: string) => `(tyhjä = asetusten oletus ${oletus})`,

  // --- Projektin seuranta -------------------------------------------------
  'projekti.tunnit': 'Tunnit',
  'projekti.tunnitSelite': 'Kaikki projektille kirjatut tunnit, myös ei-laskutettavat',
  'projekti.arvo': 'Arvo',
  'projekti.arvoSelite': 'Vain laskutettavien kirjausten arvo',
  'projekti.arvoEiNakyvissa':
    'Arvobudjetti ei ole näkyvissäsi. Tuntibudjetti yllä on työn suunnittelun tietoa ja näkyy kaikille.',
  'projekti.eiAikataulua': 'Projektilla ei ole aikataulua.',
  'projekti.aikataulu': (alkaa: string, paattyy: string) => `Aikataulu ${alkaa} – ${paattyy}`,
  'projekti.kulunut': (osuus: string) => `kulunut ${osuus}`,
  'projekti.eiBudjettia': (kaytetty: string) => `Budjettia ei ole asetettu. Käytetty ${kaytetty}.`,
  'projekti.kaytettyOsuus': (osuus: string) => `${osuus} käytetty`,
  'projekti.jaljella': (maara: string) => `, ${maara} jäljellä`,
  'projekti.aikataulustaKulunut': (osuus: string) => ` · aikataulusta kulunut ${osuus}`,
  'projekti.aikataulumerkki': (osuus: string) => `Aikataulusta kulunut ${osuus}`,
  'projekti.htpLisa': (kaytetty: string, budjetti: string, kerroin: string) =>
    `${kaytetty} / ${budjetti} · 1 htp = ${kerroin} h`,
  'projekti.laskutettavienOsuus': (osuus: string) => `Laskutettavien osuus tunneista ${osuus}`,
  'projekti.tehtavalajeittain': 'Tehtävälajeittain',
  'projekti.tyontekijoittain': 'Työntekijöittäin',
  'projekti.kertyma': 'Kertymä kuukausittain',
  'projekti.budjettimerkki': 'Budjetti',

  // --- Hinnasto -----------------------------------------------------------
  'hinnasto.otsikko': 'Hinnasto',
  'hinnasto.takautuva': 'Takautuva hintalaskenta',
  'hinnasto.hinnoittelemattomatAlku': 'Hinnoittelemattomia laskutettavia kirjauksia:',
  'hinnasto.hinnoittelemattomatLoppu': (asiakkaat: number) =>
    `/ ${asiakkaat} asiakasta. Nämä eivät päädy laskulle, ja ne estävät kuukauden lukituksen ilman erillistä kuittausta.`,
  'hinnasto.oletushinta': 'Oletushinta',
  'hinnasto.vaihteluvali': 'Vaihteluväli',
  'hinnasto.omatHinnat': 'Omat hinnat',
  'hinnasto.omatHinnatArvo': (tehtavalajit: number, projektit: number) =>
    `${tehtavalajit} tehtävälajia · ${projektit} projektia`,
  'hinnasto.hinnoittelematta': 'Hinnoittelematta',
  'hinnasto.ajoSelite':
    'Laskee kirjausten hinnat uudelleen nykyisellä hinnastolla. Koskee vain laskutettavia kirjauksia; ei-laskutettavat säilyvät hinnattomina. Lukittu kuukausi torjuu ajon.',
  'hinnasto.alkaen': 'Alkaen',
  'hinnasto.asti': 'Asti',
  'hinnasto.perusteluSelite':
    'Pakollinen, vähintään 10 merkkiä. Tallentuu muutoslokiin yhdessä vaikutusyhteenvedon kanssa.',
  'hinnasto.perusteluEsimerkki':
    'Esim. Puitesopimuksen hinnantarkistus takautuvasti 1.1.2026 alkaen',
  'hinnasto.ajoTehty': 'Ajo tehty',
  'hinnasto.kuivaharjoitus': 'Kuivaharjoitus',
  'hinnasto.muuttuu': 'Muuttuu',
  'hinnasto.erotus': 'Erotus',
  'hinnasto.ennen': 'Ennen',
  'hinnasto.jalkeen': 'Jälkeen',
  'hinnasto.ajaMuutos': 'Aja muutos',
  'hinnasto.ajoEpaonnistui': 'Ajo epäonnistui.',

  // --- Käyttäjät ----------------------------------------------------------
  'kayttajat.selite':
    'Käyttäjiä ei luoda käsin: tili syntyy ensimmäisellä kirjautumisella Microsoft-tunnuksilla.',
  'kayttajat.vastuuasiakkaat': 'Vastuuasiakkaat',
  'kayttajat.passivoitu': 'passivoitu',
  'kayttajat.kayttajaOtsikko': (nimi: string) => `Käyttäjä · ${nimi}`,
  'kayttajat.vastuuOtsikko': (nimi: string) => `Vastuuasiakkaat · ${nimi}`,
  'kayttajat.asiakasvastaavaSelite':
    'Asiakasvastaava näkee vain vastuuasiakkaidensa tunnit ja rahamäärät. Liitä asiakkaat erikseen — ilman niitä hän ei näe mitään.',
  'kayttajat.aktiivinenSelite': ' — passivointi katkaisee istunnot heti',
  'kayttajat.eiVastuuasiakkaita': 'Ei vastuuasiakkaita.',
  'kayttajat.lisaaAsiakas': 'Lisää asiakas hakemalla…',
  'kayttajat.poistaAsiakas': (nimi: string) => `Poista ${nimi}`,
  'kayttajat.kirjautuminen': 'Kirjautuminen',
  'kayttajat.microsoftTili': 'Microsoft-tili',
  'kayttajat.paikallinenTili': 'Paikallinen salasana',
  'kayttajat.eiKirjautumistapaa': 'Ei kirjautumistapaa',
  'kayttajat.eiKirjautumistapaaSelite':
    'Odottaa ensimmäistä Microsoft-kirjautumista samalla sähköpostilla.',
  'kayttajat.uusiKayttaja': 'Uusi käyttäjä',
  'kayttajat.uusiOtsikko': 'Uusi paikallinen tili',
  'kayttajat.uusiSelite':
    'Tili syntyy heti. Jos annat salasanan, käyttäjä voi kirjautua sillä ja vaihtaa sen ensimmäisellä kirjautumisella. Ilman salasanaa tili odottaa Microsoft-kirjautumista.',
  'kayttajat.salasanaOtsikko': (nimi: string) => `Salasana · ${nimi}`,
  'kayttajat.asetaSalasana': 'Aseta salasana',
  'kayttajat.nollaaSalasana': 'Nollaa salasana',
  'kayttajat.salasanaValinnainen': 'Salasana (valinnainen)',
  'kayttajat.pakotaVaihto': 'Käyttäjä vaihtaa salasanan ensimmäisellä kirjautumisella',
  'kayttajat.salasanaAsetettu': 'Salasana asetettu. Välitä se käyttäjälle turvallista reittiä.',
  'kayttajat.poistaSalasana': 'Poista salasanakirjautuminen',
  'kayttajat.poistaSalasanaVarmistus': (nimi: string) =>
    `Poistetaanko salasanakirjautuminen käyttäjältä ${nimi}? Tili säilyy ja kirjautuu jatkossa vain Microsoft-tilillä.`,
  'kayttajat.viikkotunnit': 'Viikkotuntitavoite',

  // --- Muutosloki ---------------------------------------------------------
  'muutosloki.otsikko': 'Muutosloki',
  'muutosloki.rajaa': 'Rajaa toiminnolla',
  'muutosloki.kaikkiToiminnot': 'Kaikki toiminnot',
  'muutosloki.eiMerkintoja': 'Ei merkintöjä.',
  'muutosloki.alaviite':
    'Lokiin kirjataan hinnat, budjetit, roolit, asiakasvastuut ja viennit. Tuntikirjauksia ei lokiteta rivikohtaisesti: ne ovat itsessään aikaleimattuja, ja niiden muokkausikkunan sulkee kuukauden lukitus. Lukitushistoria on Kuukaudet-välilehdellä.',
  'muutosloki.CUSTOMER_CREATE': 'Asiakas luotu',
  'muutosloki.CUSTOMER_UPDATE': 'Asiakas muutettu',
  'muutosloki.TASK_TYPE_CREATE': 'Tehtävälaji luotu',
  'muutosloki.TASK_TYPE_UPDATE': 'Tehtävälaji muutettu',
  'muutosloki.TASK_TYPE_TEMPLATE_APPLY': 'Tehtävälajipohja levitetty',
  'muutosloki.PROJECT_CREATE': 'Projekti luotu',
  'muutosloki.PROJECT_UPDATE': 'Projekti muutettu',
  'muutosloki.ASSIGNMENT_CHANGE': 'Asiakasvastuut muutettu',
  'muutosloki.CUSTOMER_CONTACT_CREATE': 'Yhteyshenkilö lisätty',
  'muutosloki.CUSTOMER_CONTACT_UPDATE': 'Yhteyshenkilö muutettu',
  'muutosloki.CUSTOMER_CONTACT_DELETE': 'Yhteyshenkilö poistettu',
  'muutosloki.CUSTOMER_LINK_CREATE': 'Dokumenttilinkki lisätty',
  'muutosloki.CUSTOMER_LINK_UPDATE': 'Dokumenttilinkki muutettu',
  'muutosloki.CUSTOMER_LINK_DELETE': 'Dokumenttilinkki poistettu',
  'muutosloki.USER_UPDATE': 'Käyttäjä muutettu',
  'muutosloki.RATE_RECALCULATE': 'Takautuva hintalaskenta',
  'muutosloki.SETTINGS_UPDATE': 'Järjestelmäasetuksen muutos',
  'muutosloki.BRANDING_UPDATE': 'Yrityksen tunnuksen muutos',

  // --- Kuukaudet ----------------------------------------------------------
  'kuukaudet.edellinenVuosi': 'Edellinen vuosi',
  'kuukaudet.seuraavaVuosi': 'Seuraava vuosi',
  'kuukaudet.kuukausi': 'Kuukausi',
  'kuukaudet.lukittu': 'Lukittu',
  'kuukaudet.avoin': 'Avoin',
  'kuukaudet.avaa': 'Avaa',
  'kuukaudet.lukitse': 'Lukitse',
  'kuukaudet.historia': 'Historia',
  'kuukaudet.tapahtumaLukittu': 'lukittu',
  'kuukaudet.tapahtumaAvattu': 'avattu',
  'kuukaudet.eiTapahtumia': 'Ei tapahtumia tältä vuodelta.',
  'kuukaudet.lukitseOtsikko': (kuukausi: string) => `Lukitse ${kuukausi}`,
  'kuukaudet.avaaOtsikko': (kuukausi: string) => `Avaa ${kuukausi}`,
  'kuukaudet.kootaan': 'Kootaan tarkistuslistaa…',
  'kuukaudet.hinnoittelemattomat': (maara: number) =>
    maara === 1
      ? '1 laskutettava kirjaus ilman hintaa'
      : `${maara} laskutettavaa kirjausta ilman hintaa`,
  'kuukaudet.hinnoittelemattomatSelite':
    'Nämä eivät päädy laskulle. Hinnoittele asiakkaat tai kuittaa tietoisesti — lukituksen jälkeen niitä ei voi korjata avaamatta kuukautta.',
  'kuukaudet.kappaletta': (maara: number) => `${maara} kpl`,
  'kuukaudet.kuittaanJaLukitsen': 'Kuittaan hinnoittelemattomat ja lukitsen silti',
  'kuukaudet.edellinenAuki': 'Edellinen kuukausi on yhä auki',
  'kuukaudet.edellinenAukiSelite':
    'Lukitseminen onnistuu silti, mutta tarkista onko edellinen kuukausi tarkoitus jättää avoimeksi.',
  'kuukaudet.tarkistamatta': (maara: number) =>
    maara === 1 ? '1 asiakas tarkistamatta' : `${maara} asiakasta tarkistamatta`,
  'kuukaudet.tarkistamattaSelite':
    'Kuittaus puuttuu tai kirjauksia on muutettu kuittauksen jälkeen. Lukitseminen onnistuu silti — merkintä kertoo vain, mitä on käyty läpi.',
  'kuukaudet.muuttunutKuittauksenJalkeen': ' — muuttunut kuittauksen jälkeen',
  'kuukaudet.ilmanVastaavaa': (maara: number) =>
    maara === 1 ? '1 asiakas ilman asiakasvastaavaa' : `${maara} asiakasta ilman asiakasvastaavaa`,
  'kuukaudet.ilmanVastaavaaSelite': 'Näiden tunteja ei ole kukaan tarkistanut.',
  'kuukaudet.kirjausta': (maara: number) => (maara === 1 ? '1 kirjaus' : `${maara} kirjausta`),
  'kuukaudet.vajaat': (maara: number) =>
    maara === 1 ? '1 vajaa kuukausi' : `${maara} vajaata kuukautta`,
  'kuukaudet.ylipitkatPaivat': 'Päiviä, joilla on yli 24 tuntia',
  'kuukaudet.perusteluEsimerkki': 'Esim. Elokuu laskutettu',
  'kuukaudet.lukitseKuukausi': 'Lukitse kuukausi',
  'kuukaudet.lukitusEpaonnistui': 'Lukitus epäonnistui.',
  'kuukaudet.avausSelite':
    'Avaus ei poista mitään. Se sallii kirjausten lisäämisen ja muokkaamisen uudelleen ja jää lokiin perusteluineen.',
  'kuukaudet.miksiAvataan': 'Miksi kuukausi avataan?',
  'kuukaudet.avausPerusteluEsimerkki': 'Esim. Kolme kirjausta puuttui NORDICin projektilta',
  'kuukaudet.vahintaanMerkkia': (merkkeja: number) =>
    `Vähintään ${merkkeja} merkkiä. Näkyy historiassa sellaisenaan.`,
  'kuukaudet.avaaKuukausi': 'Avaa kuukausi',
  'kuukaudet.avausEpaonnistui': 'Avaus epäonnistui.',

  // --- Järjestelmäasetukset -----------------------------------------------
  'asetukset.otsikko': 'Järjestelmäasetukset',
  'asetukset.valuutta': 'Valuutta',
  'asetukset.valuuttaSelite':
    'Valuutta on koko järjestelmän asetus: se koskee kaikkia käyttäjiä, asiakkaita ja projekteja. Muutos näkyy muille heidän seuraavalla sivunlatauksellaan.',
  'asetukset.valuuttaVaroitus':
    'Vaihto ei muunna lukuja. Tuntihinnat, budjetit ja jo kirjattujen tuntien arvot pysyvät ennallaan — vain valuutta niiden vieressä vaihtuu.',
  'asetukset.valuuttaKentta': 'Järjestelmän valuutta',
  'asetukset.esimerkki': 'Näin luvut näkyvät',
  'asetukset.esimerkkiTuntihinta': 'Tuntihinta',
  'asetukset.esimerkkiSumma': 'Kirjausten arvo',
  'asetukset.tallenna': 'Tallenna valuutta',
  'asetukset.tallennetaan': 'Tallennetaan…',
  'asetukset.tallennettu': 'Valuutta tallennettu.',
  'asetukset.vahvistus': (valuutta: string) =>
    `Järjestelmän valuutaksi tulee ${valuutta} kaikille käyttäjille.\n\nLukuja ei muunneta: 115,00 pysyy lukuna 115,00, vain valuutta vaihtuu.\n\nJatketaanko?`,

  // --- Ulkoasu ------------------------------------------------------------
  'ulkoasu.otsikko': 'Ulkoasu',
  'ulkoasu.teema': 'Teema',
  'ulkoasu.teemaSelite':
    'Valinta tallentuu tähän selaimeen, ei käyttäjätiliisi. Toisella koneella tai toisessa selaimessa teema valitaan erikseen.',
  'ulkoasu.teemaVaalea': 'Vaalea',
  'ulkoasu.teemaVaaleaSelite': 'Aina vaalea taustasta riippumatta.',
  'ulkoasu.teemaTumma': 'Tumma',
  'ulkoasu.teemaTummaSelite': 'Aina tumma taustasta riippumatta.',
  'ulkoasu.teemaJarjestelma': 'Järjestelmän mukaan',
  'ulkoasu.teemaJarjestelmaSelite': 'Seuraa käyttöjärjestelmän vaalea/tumma-asetusta.',
  'ulkoasu.jarjestelmaNytTumma': 'Järjestelmä on nyt tummassa tilassa.',
  'ulkoasu.jarjestelmaNytVaalea': 'Järjestelmä on nyt vaaleassa tilassa.',
  'ulkoasu.kieli': 'Kieli',
  'ulkoasu.kieliSelite':
    'Valinta tallentuu tähän selaimeen samoin kuin teema. Ilman valintaa käytetään selaimen kieltä. Asiakkaiden, projektien ja kirjausten omat tekstit näkyvät aina sellaisina kuin ne on tallennettu.',
  'ulkoasu.kieliFiSelite': 'Sovelluksen alkuperäinen kieli.',
  'ulkoasu.kieliEnSelite': 'Käyttöliittymä englanniksi.',
  'ulkoasu.varit': 'Asiakasvärit',
  'ulkoasu.varitSelite':
    'Jokainen asiakas saa oman sävynsä kalenterissa, kirjauslomakkeella ja asiakasvalitsimessa. Sävy kertoo vain, kenelle työ on tehty — laskutettavuus, lukitus ja huomautukset näkyvät merkkeinä kuten ennenkin. Valinta tallentuu tähän selaimeen samoin kuin teema.',
  'ulkoasu.varitKaytossa': 'Käytössä',
  'ulkoasu.varitKaytossaSelite':
    'Asiakaskoodilla on värillinen tausta ja kalenterikortilla värillinen raita.',
  'ulkoasu.varitPois': 'Pois',
  'ulkoasu.varitPoisSelite': 'Pelkkä asiakaskoodi ilman väriä. Mitään tietoa ei jää näkymättä.',

  // --- API-tunnukset ------------------------------------------------------
  'tunnukset.otsikko': 'API-tunnukset',
  'tunnukset.selite':
    'Tunnuksella ajetaan tuonti skriptistä ilman kirjautumista. Tunnus näytetään vain kerran luonnin yhteydessä — kadonnut tunnus peruutetaan ja luodaan uusi.',
  'tunnukset.rajaus':
    'Tunnuksella pääsee tuontipäätteisiin ja lukupäätteisiin. Sillä ei voi avata kuukausia, hallita vastuita eikä luoda lisää tunnuksia.',
  'tunnukset.nimi': 'Nimi',
  'tunnukset.nimiEsimerkki': 'esim. Historiamigraatio 2026',
  'tunnukset.rooli': 'Rooli',
  'tunnukset.voimassa': 'Voimassa (pv)',
  'tunnukset.luo': 'Luo tunnus',
  'tunnukset.kertaalleen':
    'Kopioi tunnus nyt. Sitä ei voi näyttää uudelleen — kannassa on vain tiiviste.',
  'tunnukset.kopioi': 'Kopioi',
  'tunnukset.kopioitu': 'Kopioitu',
  'tunnukset.piilota': 'Olen tallentanut sen, piilota',
  'tunnukset.tila': 'Tila',
  'tunnukset.tila.active': 'Voimassa',
  'tunnukset.tila.expired': 'Vanhentunut',
  'tunnukset.tila.revoked': 'Peruutettu',
  'tunnukset.viimeksi': 'Viimeksi käytetty',
  'tunnukset.vanhenee': 'Vanhenee',
  'tunnukset.eiKaytetty': 'Ei käytetty',
  'tunnukset.eiTunnuksia': 'Ei tunnuksia.',
  'tunnukset.peruuta': 'Peruuta tunnus',
  'tunnukset.luonut': (nimi: string, pvm: string) => `${nimi} · ${pvm}`,
  'tunnukset.vahvistus': (nimi: string) =>
    `Peruutetaanko tunnus ”${nimi}”?\n\nSe lakkaa toimimasta heti, ja sitä käyttävä skripti alkaa saada virheen 401.`,
  'muutosloki.IMPORT_RUN': 'Tuontiajo',
  'muutosloki.API_TOKEN_CREATE': 'API-tunnuksen luonti',
  'muutosloki.API_TOKEN_REVOKE': 'API-tunnuksen peruutus',
  'muutosloki.EXPORT': 'Vienti',
  'muutosloki.KANBAN_LANE_CREATE': 'Uimarata luotu',
  'muutosloki.KANBAN_LANE_UPDATE': 'Uimarata muutettu',
  'muutosloki.KANBAN_LANE_DELETE': 'Uimarata poistettu',
  'muutosloki.KANBAN_TASK_CREATE': 'Tehtävä luotu',
  'muutosloki.KANBAN_TASK_UPDATE': 'Tehtävä muutettu',
  'muutosloki.KANBAN_TASK_MOVE': 'Tehtävä siirretty',
  'muutosloki.KANBAN_TASK_COPY': 'Tehtävä monistettu',
  'muutosloki.KANBAN_TASK_DELETE': 'Tehtävä poistettu',
  'muutosloki.KANBAN_COMMENT_CREATE': 'Kommentti lisätty',
  'muutosloki.KANBAN_COMMENT_UPDATE': 'Kommentti muokattu',
  'muutosloki.KANBAN_COMMENT_DELETE': 'Kommentti poistettu',
  'muutosloki.KANBAN_REMINDER_CREATE': 'Muistutus asetettu',
  'muutosloki.KANBAN_REMINDER_UPDATE': 'Muistutus muutettu',
  'muutosloki.KANBAN_REMINDER_DELETE': 'Muistutus peruttu',
  'muutosloki.KANBAN_REACTION_ADD': 'Reaktio lisätty',
  'muutosloki.KANBAN_REACTION_REMOVE': 'Reaktio poistettu',
  'muutosloki.KANBAN_MILESTONE_CREATE': 'Milestone luotu',
  'muutosloki.KANBAN_MILESTONE_UPDATE': 'Milestone muutettu',
  'muutosloki.KANBAN_MILESTONE_DELETE': 'Milestone poistettu',
  'muutosloki.KANBAN_TASK_MILESTONE': 'Tehtävän milestone vaihdettu',
  'muutosloki.PARTNER_CREATE': 'Kumppani lisätty',
  'muutosloki.PARTNER_UPDATE': 'Kumppani muutettu',
  'muutosloki.PARTNER_DELETE': 'Kumppani poistettu',
  'muutosloki.PARTNER_CONTACT_CREATE': 'Kumppanin yhteyshenkilö lisätty',
  'muutosloki.PARTNER_CONTACT_UPDATE': 'Kumppanin yhteyshenkilö muutettu',
  'muutosloki.PARTNER_CONTACT_DELETE': 'Kumppanin yhteyshenkilö poistettu',

  // --- Koneen ehdotukset (backlog 5) --------------------------------------
  'ehdotus.otsikko': 'Koneen ehdotus',
  'ehdotus.selite':
    'Agentti ehdotti tätä kirjausta. Se ei ole kirjaus ennen kuin vahvistat sen, ja kesto on sinun sanottavasi — sitä agentti ei saanut arvata.',
  'ehdotus.perustelu': 'Peruste',
  'ehdotus.lahde': 'Lähde',
  'ehdotus.kestoPuuttuu': 'Valitse kesto. Ilman sitä ehdotusta ei voi vahvistaa.',
  'ehdotus.kestoOhje': 'Voit vielä muuttaa kestoa ennen vahvistusta.',
  'ehdotus.vahvista': 'Vahvista kirjaukseksi',
  'ehdotus.vahvistettu': 'Ehdotus vahvistettu kirjaukseksi.',
  'ehdotus.hylkaa': 'Hylkää',
  'ehdotus.hylatty': 'Ehdotus hylätty.',

  // --- Agenttitunnus ja MCP (backlog 5) -----------------------------------
  'agentti.otsikko': 'Agentti ja MCP',
  'agentti.selite':
    'Agentti — esimerkiksi Claude Code — voi auttaa muistamaan, kenelle ja mitä olet tehnyt. Se toimii sinun puolestasi omalla tunnuksellaan.',
  'agentti.rajatOtsikko': 'Mitä agentti voi ja ei voi tehdä',
  'agentti.rajaEhdotus':
    'Se ei kirjaa tunteja. Se tekee ehdotuksia, jotka näkyvät kalenterissa vahvistettavina.',
  'agentti.rajaKesto':
    'Se ei kerro kestoa. Näppäimistöaika ei ole laskutettavaa aikaa, joten kauanko on aina sinun sanottavasi.',
  'agentti.rajaOmat': 'Se näkee vain sinun omat kirjauksesi, ei kenenkään muun.',
  'agentti.rajaIkkuna': 'Se yltää kuluvaan ja edelliseen kuukauteen sekä viikon eteenpäin.',
  'agentti.rajaRahat': 'Se ei näe tuntihintoja eikä euromääriä.',
  'agentti.luo': 'Luo agenttitunnus',
  'agentti.nimiEsimerkki': 'esim. Claude Code, työläppäri',
  'agentti.kertaalleen':
    'Kopioi tunnus nyt. Sitä ei voi näyttää uudelleen — kannassa on vain tiiviste.',
  'agentti.asennus': 'Asennus Claude Codeen',
  'agentti.asennusSelite':
    'Aja tämä komento koneellasi. Se lisää palvelimen Claude Coden käyttöön tällä tunnuksella.',
  'agentti.eiTunnuksia': 'Sinulla ei ole agenttitunnuksia.',

  // Esimerkkikehotteet. Nämä ovat sivun konkreettisin osa: rajaukset
  // kertovat mitä agentti ei tee, ja nämä sen, mitä sille sanotaan.
  'agentti.esimerkitOtsikko': 'Mitä agentille sanotaan',
  'agentti.esimerkitSelite':
    'Kirjoita nämä Claude Codelle siinä repossa, jossa työ on tehty. Agentti hakee asiakkaiden ja projektien tunnisteet itse — sinun ei tarvitse tietää niitä.',
  'agentti.esimPaivaOtsikko': 'Päivän päätteeksi',
  'agentti.esimPaivaKehote': 'Katso tämän päivän commitit ja ehdota tunnit.',
  'agentti.esimPaivaSelite': 'Ehdotukset ilmestyvät kalenteriin. Käyt ne läpi ja annat kestot.',
  'agentti.esimUnohtunutOtsikko': 'Unohtunut päivä',
  'agentti.esimUnohtunutKehote': 'Mitä tein viime torstaina? Ehdota kirjaus siltä päivältä.',
  'agentti.esimUnohtunutSelite':
    'Agentti lukee haaran ja commitit siltä päivältä. Toimii edellisen kuukauden alusta lähtien.',
  'agentti.esimProjektiOtsikko': 'Kohdistus projektille',
  'agentti.esimProjektiKehote':
    'Tämän repon työ menee Acmen PORT26-projektille. Ehdota eilisen tunnit sinne.',
  'agentti.esimProjektiSelite':
    'Ilman projektia kirjaus menee pelkälle asiakkaalle, ja projektin budjettiseuranta jää vajaaksi.',
  'agentti.esimTarkistusOtsikko': 'Ennen ehdottamista',
  'agentti.esimTarkistusKehote': 'Mitä olen jo kirjannut tällä viikolla?',
  'agentti.esimTarkistusSelite':
    'Näet mitä on jo kirjattu, joten päällekkäisiä ehdotuksia ei synny.',
  'agentti.esimKuukausiOtsikko': 'Kuun vaihteessa',
  'agentti.esimKuukausiKehote': 'Onko elokuu kirjattu täyteen?',
  'agentti.esimKuukausiSelite': 'Vastaa omista summistasi ja kertoo, onko kuukausi jo lukittu.',

  // Taulut (PROJEKTINHALLINTA 14). Sama tunnus, eri työnkulku.
  'agentti.taulutOtsikko': 'Taulut',
  'agentti.taulutSelite':
    'Sama tunnus toimii myös Taulut-näkymässä: agentti lukee tehtävät, poimii sille osoitetut ja kirjoittaa työlokia sinun nimissäsi.',
  'agentti.tauluNakee': 'Se näkee samat taulut kuin sinä — ne asiakkuudet, joiden jäsen olet.',
  'agentti.tauluSiirto':
    'Se siirtää vain tehtäviä, jotka on osoitettu AI-assistentille tai sinulle, tai sinun luomiasi osoittamattomia.',
  'agentti.tauluDone':
    'Se siirtää tehtävän enintään IN REVIEW -osioon. DONE-osioon siirrät sinä, kun olet tarkistanut työn.',
  'agentti.tauluJumissa':
    'BLOCKED-osioon se siirtää vain kommentin kanssa, joka kertoo mikä estää.',
  'agentti.tauluKommentti':
    'Sen kommentit näkyvät sinun nimelläsi ja robottimerkillä, jossa on tunnuksen nimi. Kommentti ei ole tuntikirjaus.',
  'agentti.tauluLuonti':
    'Se luo tehtävän vain pyynnöstäsi, TODO- tai INFO-osioon. Tehtävä näkyy sinun luomanasi ja robottimerkillä.',
  'agentti.tauluMilestonet':
    'Se lukee uimaratojen milestonet ja liittää tehtäviä niihin pyynnöstäsi. Milestonejen luonti ja saavutetuksi merkitseminen ovat asiakasvastaavan.',
  'agentti.tauluRaportti':
    'Se laatii asiakasraportin pyynnöstäsi, jos olet asiakasvastaava tai ylläpitäjä. Raportti tulee sinulle; asiakkaalle sen lähetät sinä.',
  'agentti.esimTauluOtsikko': 'Mitä on osoitettu',
  'agentti.esimTauluKehote':
    'Mitä tehtäviä minulle tai AI-assistentille on osoitettu Acmen verkkokauppaprojektin taululla?',
  'agentti.esimTauluSelite':
    'Agentti hakee taulun ja listaa tehtävät kuvauksineen ja kommentteineen.',
  'agentti.esimPoimiOtsikko': 'Tehtävän poiminta',
  'agentti.esimPoimiKehote':
    'Poimi AI-assistentille osoitettu tehtävä, tee se tässä repossa ja siirrä se tarkistettavaksi.',
  'agentti.esimPoimiSelite':
    'Agentti siirtää tehtävän DOING-osioon, tekee työn ja siirtää sen IN REVIEW -osioon kommentin kera. Sinä tarkistat ja siirrät DONE-osioon.',
  'agentti.esimTyolokiOtsikko': 'Työloki tehtävälle',
  'agentti.esimTyolokiKehote':
    'Kirjoita tehtävälle kommentti siitä, mitä tein tänään ja mihin jäin.',
  'agentti.esimTyolokiSelite':
    'Kommentti näkyy taululla robottimerkillä. Tunnit ehdotetaan erikseen kalenteriin.',
  'agentti.esimMilestoneOtsikko': 'Milestonen tilanne',
  'agentti.esimMilestoneKehote':
    'Mitkä tehtävät ovat vielä kesken Acmen verkkokauppaprojektin seuraavista milestoneista, ja kuka niistä vastaa?',
  'agentti.esimMilestoneSelite':
    'Agentti hakee jokaisen uimaradan seuraavan saavuttamattoman milestonen, sen eräpäivän, kirjatut tunnit ja avoimet tehtävät linkkeineen.',
  'agentti.esimDeadlineOtsikko': 'Deadlinet',
  'agentti.esimDeadlineKehote':
    'Mitkä Acmen taulun tehtävät ovat myöhässä? Aseta tehtävälle "Sertifikaatin uusinta" deadlineksi perjantai.',
  'agentti.esimDeadlineSelite':
    'Agentti rajaa myöhässä olevat avoimet tehtävät ja asettaa deadlinen, kun pyydät. Asettaminen onnistuu vain asiakasvastaavan tai ylläpitäjän tunnuksella.',
  'agentti.esimRaporttiOtsikko': 'Asiakasraportti',
  'agentti.esimRaporttiKehote':
    'Tee Acmelle englanninkielinen tilannekatsaus kaikista sen tauluista, valmistuneet viimeisen kahden viikon ajalta.',
  'agentti.esimRaporttiSelite':
    'Agentti palauttaa saman Markdown-raportin kuin taulun Asiakasraportti-painike. Lue se ja lähetä itse.',
  'agentti.vinkkiOtsikko': 'Vinkki:',
  'agentti.vinkkiTeksti':
    'kirjoita repon CLAUDE.md-tiedostoon, kenelle sen työ kirjataan — esimerkiksi ”Tämän repon työ kirjataan asiakkaalle ACME, projekti PORT26”. Silloin agentin ei tarvitse kysyä sitä joka kerta, eivätkä ehdotukset osu väärälle asiakkaalle.',

  // --- Yrityksen tunnus ----------------------------------------------------
  'tunnus.otsikko': 'Yrityksen tunnus',
  'tunnus.selite':
    'Tunnus näkyy yläpalkissa ja kirjautumissivulla. Ilman omaa tunnusta käytetään Devikone Oy:n tunnusta.',
  'tunnus.koskeeKaikkia':
    'Toisin kuin teema ja kieli, tunnus ja nimi tallentuvat palvelimelle ja näkyvät kaikille käyttäjille.',
  'tunnus.nimi': 'Yrityksen nimi',
  'tunnus.nimiSelite':
    'Näkyy kirjautumissivulla tunnuksen alla ja tunnuksen vaihtoehtoisena tekstinä ruudunlukijalle.',
  'tunnus.tallennaNimi': 'Tallenna nimi',
  'tunnus.tallennettu': 'Tallennettu.',
  'tunnus.vaaleaTausta': 'Vaalealle taustalle',
  'tunnus.tummaTausta': 'Tummalle taustalle',
  'tunnus.oletus': 'Oletustunnus',
  'tunnus.oletusKaytossa':
    'Käytössä on sovelluksen mukana tuleva Devikone Oy:n tunnus. Lisää oma tunnus vaihtaaksesi sen.',
  'tunnus.rajat': (koko: string) =>
    `PNG, JPEG, WebP tai SVG, enintään ${koko}. Jos vain toinen versio on annettu, sitä käytetään molemmilla taustoilla.`,
  'tunnus.lisaa': 'Valitse kuva',
  'tunnus.vaihda': 'Vaihda kuva',
  'tunnus.palautaOletus': 'Poista',
  'tunnus.esikatseluAlt': 'Tunnuksen esikatselu',
  'tunnus.logoAlt': 'Yrityksen tunnus',
  'tunnus.virheTyyppi': 'Tunnuksen on oltava PNG-, JPEG-, WebP- tai SVG-kuva.',
  'tunnus.virheKoko': (koko: string) => `Kuva on liian suuri. Enimmäiskoko on ${koko}.`,

  // --- Koulutukset (docs/KOULUTUKSET.md) ----------------------------------
  'navi.koulutukset': 'Koulutukset',

  'koulutus.otsikko': 'Koulutukset',
  'koulutus.johdanto':
    'Tässä ovat sinulle tarjolla olevat koulutukset. Pakolliset on käytävä, ja suoritus on voimassa määräajan.',
  'koulutus.eiKoulutuksia': 'Sinulle ei ole tällä hetkellä tarjolla koulutuksia.',
  'koulutus.pakollinen': 'Pakollinen',
  'koulutus.vapaaehtoinen': 'Vapaaehtoinen',
  'koulutus.kesto': (minuutit: number) => `noin ${minuutit} min`,
  'koulutus.suoritettu': (pvm: string) => `Suoritettu ${pvm}`,
  'koulutus.voimassa': (pvm: string) => `Voimassa ${pvm} asti`,
  'koulutus.eiVanhene': 'Ei vanhene',
  'koulutus.vanheneePaivissa': (paivia: number) =>
    paivia === 0
      ? 'Vanhenee tänään'
      : paivia === 1
        ? 'Vanhenee huomenna'
        : `Vanhenee ${paivia} päivän kuluttua`,
  'koulutus.vanhentunut': (pvm: string) => `Vanhentunut ${pvm}`,
  'koulutus.eteneminen': (luettu: number, yhteensa: number) =>
    `${luettu}/${yhteensa} osiota luettu`,

  'koulutus.tila.NOT_STARTED': 'Aloittamatta',
  'koulutus.tila.IN_PROGRESS': 'Kesken',
  'koulutus.tila.EXAM_OPEN': 'Tentti kesken',
  'koulutus.tila.PASSED': 'Voimassa',
  'koulutus.tila.EXPIRING': 'Vanhenemassa',
  'koulutus.tila.EXPIRED': 'Vanhentunut',

  'koulutus.varoitusPuuttuu': (maara: number) =>
    maara === 1
      ? 'Sinulta puuttuu pakollinen koulutus.'
      : `Sinulta puuttuu ${maara} pakollista koulutusta.`,
  'koulutus.varoitusVanhenee': (maara: number) =>
    maara === 1 ? 'Yksi koulutuksesi on vanhenemassa.' : `${maara} koulutustasi on vanhenemassa.`,
  'koulutus.varoitusLinkki': 'Katso koulutukset',

  'koulutus.materiaali': 'Materiaali',
  'koulutus.osio': 'Osio',
  'koulutus.luettu': 'Luettu',
  'koulutus.aloitaMateriaali': 'Aloita materiaali',
  'koulutus.jatkaMateriaalia': 'Jatka materiaalia',
  'koulutus.kertaaMateriaali': 'Kertaa materiaali',
  'koulutus.merkitseLuetuksi': 'Merkitse luetuksi ja jatka',
  'koulutus.merkitseViimeinen': 'Merkitse luetuksi ja palaa',
  'koulutus.edellinen': 'Edellinen',
  'koulutus.seuraava': 'Seuraava',
  'koulutus.takaisinKoulutukseen': 'Takaisin koulutukseen',
  'koulutus.sisaltoaEiLoytynyt':
    'Tämän osion sisältöä ei löytynyt sovelluksesta. Ilmoita ylläpitäjälle.',

  'koulutus.tentti': 'Tentti',
  'koulutus.tenttiSaannot': (kysymyksia: number, oikein: number) =>
    `${kysymyksia} monivalintakysymystä, joista ${oikein} oikein läpäisee.`,
  'koulutus.aikaraja': (minuutit: number) => `Aikaa ${minuutit} minuuttia.`,
  'koulutus.eiAikarajaa': 'Ei aikarajaa.',
  'koulutus.yhdellaIstumalla': (minuutit: number) =>
    `Tentti tehdään yhdellä istumalla: aloitettu tentti sulkeutuu ${minuutit} minuutin kuluttua eikä sitä voi jatkaa myöhemmin.`,
  'koulutus.aloitaTentti': 'Aloita tentti',
  'koulutus.jatkaTenttia': 'Jatka tenttiä',
  'koulutus.uusiTentti': 'Uusi tentti',

  'koulutus.esto.MATERIAL_INCOMPLETE': 'Käy materiaali läpi ennen tenttiä.',
  'koulutus.esto.COOLDOWN': (kello: string) => `Uusinnan voi aloittaa klo ${kello}.`,
  'koulutus.esto.ALREADY_PASSED': 'Koulutus on suoritettu ja voimassa.',
  'koulutus.esto.ATTEMPT_OPEN': 'Sinulla on tentti kesken.',
  'koulutus.esto.NOT_PUBLISHED': 'Koulutus ei ole käytettävissä.',
  'koulutus.esto.PREREQUISITE_INCOMPLETE': (koulutus: string) =>
    `Suorita ensin koulutus "${koulutus}".`,

  'koulutus.esivaatimus': (koulutus: string) => `Edellyttää koulutusta ${koulutus}`,
  'koulutus.esivaatimusKunnossa': (koulutus: string) =>
    `Esivaatimus ${koulutus} on suoritettu ja voimassa.`,
  'koulutus.esivaatimusPuuttuu': (koulutus: string) =>
    `Tentti aukeaa, kun koulutus "${koulutus}" on suoritettu ja voimassa. Materiaalin voi lukea jo nyt.`,
  'koulutus.siirryEsivaatimukseen': 'Siirry esivaatimukseen',

  'koulutus.yritykset': 'Tenttiyritykset',
  'koulutus.eiYrityksia': 'Ei tenttiyrityksiä.',
  'koulutus.yritysTulos': (prosentti: number) => `${prosentti} %`,
  'koulutus.aikaLoppui': 'aika loppui',
  'koulutus.katsoTulos': 'Katso tulos',

  'koulutus.aani.otsikko': 'Kuuntele osio',
  'koulutus.aani.toista': 'Toista',
  'koulutus.aani.tauko': 'Keskeytä',
  'koulutus.aani.taakse': 'Siirry 15 sekuntia taaksepäin',
  'koulutus.aani.kelaus': 'Kelaa äänitettä',
  'koulutus.aani.ilmoitus': 'Ääni on tekoälyn tuottama. Kirjoitettu materiaali on alkuperäinen.',
  'koulutus.aani.virhe': 'Äänitteen toisto ei onnistunut. Materiaalin voi lukea tekstinä.',

  'tentti.kysymys': (nro: number, yhteensa: number) => `Kysymys ${nro}/${yhteensa}`,
  'tentti.valitseKaikki':
    'Tässä kysymyksessä oikeita vaihtoehtoja voi olla useampi. Valitse kaikki oikeat — kysymys on oikein vain, jos jokainen oikea on valittuna eikä yhtään väärää.',
  'tentti.vastattu': (vastattu: number, yhteensa: number) => `Vastattu ${vastattu}/${yhteensa}`,
  'tentti.aikaaJaljella': 'Aikaa jäljellä',
  'tentti.aikaLoppumassa': 'Aikaa on vähän jäljellä.',
  'tentti.palauta': 'Palauta tentti',
  'tentti.palautetaan': 'Palautetaan…',
  'tentti.vahvistaOtsikko': 'Palauta tentti?',
  'tentti.vahvistaTeksti': (vastaamatta: number) =>
    vastaamatta === 0
      ? 'Kaikkiin kysymyksiin on vastattu. Palautuksen jälkeen vastauksia ei voi muuttaa.'
      : `${vastaamatta} kysymykseen ei ole vastattu, ja ne lasketaan vääriksi. Palautuksen jälkeen vastauksia ei voi muuttaa.`,
  'tentti.keskeytysVaroitus':
    'Tentti on kesken. Jos poistut, kello käy silti — palaa takaisin ennen ajan loppumista.',

  'tentti.tulosLapaisi': 'Tentti läpäisty',
  'tentti.tulosHylatty': 'Tentti hylätty',
  'tentti.pisteet': (oikein: number, yhteensa: number, prosentti: number) =>
    `${oikein}/${yhteensa} oikein (${prosentti} %)`,
  'tentti.rima': (oikein: number) => `Läpäisyyn tarvittiin ${oikein} oikein.`,
  'tentti.aikaLoppuiSelite':
    'Aika loppui kesken. Siihen mennessä annetut vastaukset on arvosteltu, ja vastaamatta jääneet laskettiin vääriksi.',
  'tentti.suoritusVoimassa': (pvm: string) => `Suoritus on voimassa ${pvm} asti.`,
  'tentti.suoritusEiVanhene': 'Suoritus ei vanhene.',
  'tentti.uusintaMilloin': (kello: string) => `Voit uusia tentin klo ${kello} alkaen.`,
  'tentti.uusintaNyt': 'Voit uusia tentin heti.',
  'tentti.kayLapi': 'Vastaukset ja perustelut',
  'tentti.sinunVastauksesi': 'Vastauksesi',
  'tentti.oikeaVastaus': 'Oikea vastaus',
  'tentti.eiVastausta': 'Ei vastausta',
  'tentti.perustelu': 'Perustelu',

  // --- Koulutusten hallinta -----------------------------------------------
  'koulutusHallinta.otsikko': 'Koulutukset',
  'koulutusHallinta.johdanto':
    'Sisältö ja kysymykset tulevat koodista. Täällä päätetään kenelle koulutus kuuluu, kuinka tiukka tentti on ja kuinka kauan suoritus on voimassa.',
  'koulutusHallinta.synkronoi': 'Hae sisältö koodista',
  'koulutusHallinta.synkronoidaan': 'Haetaan…',
  'koulutusHallinta.synkronoitu': (muutoksia: number) =>
    muutoksia === 0 ? 'Sisältö oli jo ajan tasalla.' : `${muutoksia} koulutusta päivitetty.`,
  'koulutusHallinta.versio': (versio: number) => `Sisältöversio ${versio}`,
  'koulutusHallinta.paivitetty': (aika: string) => `Haettu koodista ${aika}`,
  'koulutusHallinta.eiHaettu': 'Sisältöä ei ole vielä haettu koodista.',
  'koulutusHallinta.osioita': (maara: number) => `${maara} osiota`,
  'koulutusHallinta.kysymyspankki': (maara: number) => `${maara} kysymystä pankissa`,
  'koulutusHallinta.tilanne': (voimassa: number, kohdennettu: number) =>
    `${voimassa}/${kohdennettu} voimassa`,
  'koulutusHallinta.puuttuu': (maara: number) => `${maara} puuttuu`,
  'koulutusHallinta.tilanneAvaa': 'Näytä ketkä ovat suorittaneet',
  'koulutusHallinta.puuttuuAvaa': 'Näytä keiltä puuttuu',

  'koulutusHallinta.kohdejoukko': (koulutus: string) => `Kohdejoukko — ${koulutus}`,
  'koulutusHallinta.kohdejoukkoSelite':
    'Ne, joille koulutus on pakollinen, sekä ne, jotka ovat suorittaneet sen ilman pakkoa.',
  'koulutusHallinta.suodatin.KAIKKI': 'Kaikki',
  'koulutusHallinta.suodatin.VOIMASSA': 'Voimassa',
  'koulutusHallinta.suodatin.PUUTTUU': 'Puuttuu',
  'koulutusHallinta.suodatin.VAPAAEHTOINEN': 'Vapaaehtoiset',
  'koulutusHallinta.eiKetaan': 'Ei ketään tällä suodattimella.',
  'koulutusHallinta.eiKohdejoukkoa':
    'Koulutusta ei ole kohdennettu kenellekään. Julkaisematon koulutus ei ole kenenkään listalla, vaikka kohdennus olisi tehty.',
  'koulutusHallinta.suoritettu': (paiva: string) => `Suoritettu ${paiva}`,
  'koulutusHallinta.eiSuoritusta': 'Ei suoritusta',
  'koulutusHallinta.yrityksia': (maara: number) =>
    maara === 1 ? '1 tenttiyritys' : `${maara} tenttiyritystä`,

  'koulutusHallinta.asetukset': 'Tentin säännöt ja voimassaolo',
  'koulutusHallinta.tila': 'Julkaisutila',
  'koulutusHallinta.tila.DRAFT': 'Luonnos',
  'koulutusHallinta.tila.PUBLISHED': 'Julkaistu',
  'koulutusHallinta.tila.ARCHIVED': 'Arkistoitu',
  'koulutusHallinta.lapaisyraja': 'Läpäisyraja (%)',
  'koulutusHallinta.kysymyksia': 'Kysymyksiä tentissä',
  'koulutusHallinta.aikaraja': 'Aikaraja (min)',
  'koulutusHallinta.aikarajaSelite': 'Tyhjä = ei aikarajaa.',
  'koulutusHallinta.sessio': 'Session yläraja (min)',
  'koulutusHallinta.sessioSelite':
    'Kuinka kauan aloitettu tentti elää. Tämä on yhden istuman sääntö, ei aikaraja.',
  'koulutusHallinta.jaahy': 'Jäähy hylätyn jälkeen (min)',
  'koulutusHallinta.voimassaolo': 'Voimassaolo (kk)',
  'koulutusHallinta.voimassaoloSelite': 'Tyhjä = suoritus ei vanhene.',
  'koulutusHallinta.varoitus': 'Varoitus ennen vanhenemista (pv)',
  'koulutusHallinta.materiaaliPakko': 'Materiaali on käytävä läpi ennen tenttiä',
  'koulutusHallinta.esivaatimus': 'Esivaatimus',
  'koulutusHallinta.esivaatimusSelite':
    'Tämä koulutus on oltava suoritettuna ja voimassa ennen kuin tentin voi aloittaa. Materiaalin lukemista esivaatimus ei estä.',
  'koulutusHallinta.eiEsivaatimusta': 'Ei esivaatimusta',
  'koulutusHallinta.esivaatimusRivi': (koulutus: string) => `Esivaatimus: ${koulutus}`,

  'koulutusHallinta.kohdennukset': 'Kohdennukset',
  'koulutusHallinta.kohdennusSelite':
    'Rooli kohdentaa koulutuksen kaikille sen rooleille — myös uusille käyttäjille. Henkilökohtainen kohdennus voittaa roolin.',
  'koulutusHallinta.roolit': 'Roolit',
  'koulutusHallinta.henkilot': 'Yksittäiset henkilöt',
  'koulutusHallinta.eiKohdennettu': 'Ei kohdennettu',
  'koulutusHallinta.pakollinen': 'Pakollinen',
  'koulutusHallinta.tarjolla': 'Tarjolla',
  'koulutusHallinta.lisaaHenkilo': 'Lisää henkilö',
  'koulutusHallinta.poista': 'Poista kohdennus',

  'koulutusHallinta.kirjaaSuoritus': 'Kirjaa suoritus käsin',
  'koulutusHallinta.kirjaaSelite':
    'Koulutus on voitu käydä muualla. Käsin kirjattu suoritus nimeää kirjaajansa ja perustelunsa.',
  'koulutusHallinta.henkilo': 'Henkilö',
  'koulutusHallinta.suorituspaiva': 'Suorituspäivä',
  'koulutusHallinta.peruste': 'Mihin suoritus perustuu',
  'koulutusHallinta.kirjaa': 'Kirjaa suoritus',
  'koulutusHallinta.kirjattu': 'Suoritus kirjattu.',

  // --- Koulutusraportti ----------------------------------------------------
  'koulutusRaportti.otsikko': 'Koulutustilanne',
  'koulutusRaportti.johdanto':
    'Henkilöstön koulutustila koulutuksittain. Tämä on se näkymä, jonka tiedot kysytään asiakassopimuksissa ja kilpailutuksissa.',
  'koulutusRaportti.kaikkiKoulutukset': 'Kaikki koulutukset',
  'koulutusRaportti.vainOngelmat': 'Näytä vain ne, joilla on puutteita',
  'koulutusRaportti.myosPassivoidut': 'Näytä myös passivoidut käyttäjät',
  'koulutusRaportti.eiRiveja': 'Ei näytettäviä rivejä.',
  'koulutusRaportti.henkilo': 'Henkilö',
  'koulutusRaportti.kunnossa': 'Kaikki pakolliset voimassa',
  'koulutusRaportti.puutteita': 'Puutteita',
  'koulutusRaportti.vanhenemassa': 'Vanhenemassa',
  'koulutusRaportti.kayttajia': 'Käyttäjiä',
  'koulutusRaportti.laadittu': (aika: string) => `Tilanne ${aika}`,
  'koulutusRaportti.eiKohdennettu': 'Ei kohdennettu',

  // --- Attribuutit --------------------------------------------------------
  'attribuutit.otsikko': 'Attribuutit',
  'attribuutit.johdanto':
    'Lisäkentät asiakkaalle ja projektille — esimerkiksi asiakkaan oma projektikoodi. Avain määritellään kerran täällä, ja arvo annetaan asiakkaan tai projektin tiedoissa.',
  'attribuutit.uusi': 'Uusi attribuutti',
  'attribuutit.muokkaaOtsikko': (nimi: string) => `Attribuutti · ${nimi}`,
  'attribuutit.uusiOtsikko': 'Uusi attribuutti',
  'attribuutit.avain': 'Avain',
  'attribuutit.avainSelite':
    'Tekninen tunniste: pieniä kirjaimia, numeroita ja alaviivoja. Avainta ei voi muuttaa jälkikäteen — se on CSV-sarakkeen nimi.',
  'attribuutit.avainLukittu': 'Avainta ei voi muuttaa.',
  'attribuutit.otsikkoKentta': 'Otsikko',
  'attribuutit.otsikkoSelite': 'Näytettävä nimi lomakkeilla ja raportilla.',
  'attribuutit.kohde': 'Kohde',
  'attribuutit.kohdeCUSTOMER': 'Asiakas',
  'attribuutit.kohdePROJECT': 'Projekti',
  'attribuutit.kohdeBOTH': 'Asiakas ja projekti',
  'attribuutit.kohdeSelite':
    'Asiakas ja projekti: arvo annetaan asiakkaalle ja periytyy sen projekteille, ellei projektilla ole omaa.',
  'attribuutit.muoto': 'Muotosääntö',
  'attribuutit.muotoSelite':
    'Valinnainen säännöllinen lauseke, jota arvon on vastattava. Esimerkiksi ^B\\d{9}$.',
  'attribuutit.pakollinen': 'Pakollinen',
  'attribuutit.pakollinenSelite': ' — vaaditaan uutta asiakasta tai projektia perustettaessa',
  'attribuutit.naytaRaportilla': 'Näytä raportilla',
  'attribuutit.jarjestys': 'Järjestys',
  'attribuutit.kaytossa': 'Käytössä',
  'attribuutit.poistettuKaytosta': 'poistettu käytöstä',
  'attribuutit.csvSarake': (avain: string) => `CSV-sarake: attr_${avain}`,
  'attribuutit.arvoja': (maara: number) =>
    maara === 1 ? '1 arvo annettu' : `${maara} arvoa annettu`,
  'attribuutit.eiArvoja': 'Ei arvoja',
  'attribuutit.poistaVahvistus': (nimi: string) =>
    `Poistetaanko attribuutti ${nimi}? Tämä onnistuu vain, jos sillä ei ole yhtään arvoa.`,
  'attribuutit.eiAttribuutteja':
    'Attribuutteja ei ole vielä määritelty. Perusta ensimmäinen yllä olevasta napista.',
  'attribuutit.lisatiedot': 'Lisätiedot',
  'attribuutit.eiKohteelle': 'Tälle kohteelle ei ole määritelty attribuutteja.',
  'attribuutit.peritty': 'peritty asiakkaalta',
  'attribuutit.perittyArvo': (arvo: string) => `Peritään asiakkaalta: ${arvo}`,

  // --- Viennin sarakkeet --------------------------------------------------
  'vienti.sarakkeet': 'CSV-sarakkeet',
  'vienti.sarakkeetSelite':
    'Valitse mitä tiedosto sisältää. Kuvaus ja attribuutit eivät ole oletuksena mukana — kuvaus on sisäinen muistiinpano, jota laskulle ei yleensä haluta.',
  'vienti.sarakkeitaValittu': (valittu: number, kaikki: number) =>
    `${valittu}/${kaikki} saraketta valittu`,
  'vienti.palautaOletukset': 'Palauta oletukset',
  'vienti.sarakeAttribuutit': 'Attribuutit',
  'vienti.eiSarakkeita': 'Valitse vähintään yksi sarake.',
  'vienti.vainCsv': 'Sarakevalinta koskee vain CSV:tä. JSON sisältää aina kaikki kentät.',
  'vienti.sarake.pvm': 'Päivämäärä',
  'vienti.sarake.viikko': 'Viikko',
  'vienti.sarake.kayttaja': 'Tekijä',
  'vienti.sarake.kayttaja_email': 'Tekijän sähköposti',
  'vienti.sarake.asiakas_koodi': 'Asiakkaan koodi',
  'vienti.sarake.asiakas_nimi': 'Asiakkaan nimi',
  'vienti.sarake.tehtavalaji_koodi': 'Tehtävälajin koodi',
  'vienti.sarake.tehtavalaji_nimi': 'Tehtävälajin nimi',
  'vienti.sarake.projekti_koodi': 'Projektin koodi',
  'vienti.sarake.projekti_nimi': 'Projektin nimi',
  'vienti.sarake.tunnit': 'Tunnit',
  'vienti.sarake.laskutettava': 'Laskutettava',
  'vienti.sarake.tuntihinta': 'Tuntihinta',
  'vienti.sarake.arvo': 'Arvo',
  'vienti.sarake.valuutta': 'Valuutta',
  'vienti.sarake.kuvaus': 'Kuvaus',
  'vienti.sarake.kirjaus_id': 'Kirjauksen tunniste',
  'vienti.sarake.luotu': 'Luotu',
  'vienti.sarake.muokattu': 'Muokattu',
  // --- Taulut (docs/PROJEKTINHALLINTA.md) ---------------------------------
  'taulut.otsikko': 'Taulut',
  'taulut.johdanto':
    'Kanban-taulu jokaiselle asiakkuudelle ja sen projekteille. Näet ne asiakkuudet, joihin sinut on liitetty.',
  'taulut.eiTauluja':
    'Sinua ei ole liitetty yhteenkään asiakkuuteen. Pyydä ylläpitäjää lisäämään sinut asiakkuuden jäseneksi.',
  'taulut.hae': 'Hae taulua',
  'taulut.hakuohje': 'Asiakkaan tai projektin koodi tai nimi. Enter avaa ainoan osuman.',
  'taulut.eiHakutuloksia': 'Yksikään taulu ei vastaa hakua.',
  'taulut.viimeksiKaytetyt': 'Viimeksi käytetyt',
  'taulut.asiakkuudenTaulu': 'Asiakkuuden taulu',
  'taulut.tehtavia': (maara: number) => (maara === 1 ? '1 tehtävä' : `${maara} tehtävää`),
  'taulut.passivoitu': 'Passivoitu',
  'taulut.lukutila':
    'Taulu on lukutilassa: projekti on suljettu tai asiakas passivoitu. Sisältö näkyy, mutta sitä ei voi muokata.',
  'taulut.vainLuku': 'Vain luku',
  'taulut.kopioiLinkki': 'Kopioi linkki',
  'taulut.kirjaaTunteja': 'Kirjaa tunteja',
  'taulut.kirjaaTuntejaSelite':
    'Avaa kalenterin tälle päivälle lomake esitäytettynä asiakkaalla, projektilla ja otsikolla.',
  'taulut.kirjattu': (tunnit: string, maara: number) =>
    `kirjattu ${tunnit} (${maara === 1 ? '1 kirjaus' : `${maara} kirjausta`})`,
  'taulut.kirjattuSelite': 'Tältä tehtävältä kopioidut kirjaukset näkyvyysalueellasi.',
  'taulut.relaatiot': 'Relaatiot',
  'taulut.lisaaRelaatio': 'Lisää relaatio',
  'taulut.poistaRelaatio': 'Poista relaatio',
  'taulut.eiRelaatioita': 'Ei relaatioita muihin tehtäviin.',
  'taulut.relaationLaji': 'Relaation laji',
  'taulut.haeTehtavaa': 'Hae tehtävää otsikolla…',
  'taulut.eiTehtavaOsumia': 'Ei osumia tämän asiakkuuden tauluilta.',
  'taulut.relaatioita': (maara: number) => (maara === 1 ? '1 relaatio' : `${maara} relaatiota`),
  'taulut.odottaaTehtavia': (maara: number) =>
    maara === 1 ? 'Odottaa yhtä keskeneräistä tehtävää' : `Odottaa ${maara} keskeneräistä tehtävää`,
  'taulut.relaatio.DEPENDS_ON.OUT': 'Riippuu tehtävästä',
  'taulut.relaatio.DEPENDS_ON.IN': 'Estää tehtävää',
  'taulut.relaatio.DUPLICATE_OF.OUT': 'Kaksoiskappale tehtävästä',
  'taulut.relaatio.DUPLICATE_OF.IN': 'Kaksoiskappale',
  'taulut.relaatio.RELATES_TO.OUT': 'Liittyy tehtävään',
  'taulut.relaatio.RELATES_TO.IN': 'Liittyy tehtävään',
  'taulut.relaatio.FOLLOWS.OUT': 'Seuraa tehtävää',
  'taulut.relaatio.FOLLOWS.IN': 'Edeltää tehtävää',

  // --- Muistutukset (luku 24) ---------------------------------------------
  'taulut.muistutukset': 'Muistutukset',
  'taulut.lisaaMuistutus': 'Aseta muistutus',
  'taulut.asetaMuistutus': 'Aseta',
  'taulut.eiMuistutuksia': 'Ei muistutuksia.',
  'taulut.muistutusSelite':
    'Sähköposti valittuna ajankohtana. Vastuuhenkilölle tai molemmille kohdistaa asiakasvastaava tai ylläpitäjä.',
  'taulut.peruMuistutus': 'Peru muistutus',
  'taulut.muistutusPaiva': 'Päivä',
  'taulut.muistutusKellonaika': 'Kellonaika',
  'taulut.muistutusKenelle': 'Kenelle',
  'taulut.muistutusSaate': 'Saate',
  'taulut.muistutusSaateVihje': 'Mistä muistutetaan?',
  'taulut.muistutusKohde.SETTER': 'Minulle',
  'taulut.muistutusKohde.ASSIGNEE': 'Vastuuhenkilölle',
  'taulut.muistutusKohde.BOTH': 'Molemmille',
  'taulut.muistutusEsivalinta.TOMORROW': 'Huomenna',
  'taulut.muistutusEsivalinta.NEXT_MONDAY': 'Ensi maanantaina',
  'taulut.muistutusEsivalinta.WEEKS_1': '1 vk',
  'taulut.muistutusEsivalinta.WEEKS_2': '2 vk',
  'taulut.muistutusEsivalinta.WEEKS_4': '4 vk',
  'taulut.muistutusEnnenDeadlinea': 'Ennen deadlinea',
  'taulut.muistutusEnnenDeadlineaSelite': (pvm: string) =>
    `Deadlinea edeltävänä arkipäivänä, ${pvm}`,
  'taulut.muistutusOmaAika': 'Oma aika',
  'taulut.muistutusLahetetty': 'lähetetty',
  'taulut.muistutusAsetti': (nimi: string) => `asettanut ${nimi}`,
  'taulut.muistutusKortilla': (aika: string) => `Muistutus ${aika}`,
  'taulut.muistutusAsetettu': 'Muistutus asetettu.',
  'taulut.omatMuistutukset': 'Muistutukset',
  'taulut.omatMuistutuksetSelite':
    'Odottavat muistutukset, jotka koskevat sinua. Viesti lähtee sähköpostiin valittuna ajankohtana.',
  'taulut.linkkiKopioitu': 'Linkki kopioitu',
  'taulut.asetukset': 'Ilmoitukset',
  'taulut.asetuksetSelite':
    'Tämän taulun sähköposti-ilmoitukset. Asetus koskee kaikkia taulun jäseniä, ja sen voi muuttaa asiakasvastaava tai ylläpitäjä.',
  'taulut.asetuksetTallennettu': 'Ilmoitusasetukset tallennettu.',
  'taulut.asetusJumissa': 'Viikoittainen muistutus jumissa olevista tehtävistä',
  'taulut.asetusJumissaSelite':
    'Luojalle ja asiakasvastaavalle, kun tehtävä on ollut BLOCKED-osiossa yli kahdeksan päivää. Vaatii, että muistutus on käytössä Hallinta → Asetukset -näkymässä.',
  'taulut.asetusBlocked': 'Viesti heti, kun tehtävä siirtyy BLOCKED-osioon',
  'taulut.asetusBlockedSelite': 'Luojalle ja asiakasvastaavalle, ei siirtäjälle itselleen.',
  'taulut.asetusOsoitettu': 'Viesti, kun jollekulle osoitetaan tehtävä',
  'taulut.asetusOsoitettuSelite': 'Vastuuhenkilölle, ellei hän osoittanut tehtävää itselleen.',
  'taulut.asetusMaininta': 'Viesti, kun joku mainitaan kuvauksessa tai kommentissa',
  'taulut.asetusMainintaSelite':
    'Mainitulle (@tunnus), ei mainitsijalle itselleen. Maininta näkyy Omat tehtävät -näkymässä joka tapauksessa.',
  'taulut.maininnat': 'Maininnat',
  'taulut.mainintaSelite':
    'Sinut on mainittu näissä tehtävissä @tunnuksella. Kuittaus poistaa rivin listalta.',
  'taulut.eiMainintoja': 'Ei kuittaamattomia mainintoja.',
  'taulut.mainitsiKommentissa': (nimi: string) => `${nimi} mainitsi sinut kommentissa`,
  'taulut.mainitsiKuvauksessa': (nimi: string) => `${nimi} mainitsi sinut kuvauksessa`,
  'taulut.kuittaa': 'Kuittaa',
  'taulut.kuittaaKaikki': 'Kuittaa kaikki',
  'taulut.mainintaMaara': (maara: number) =>
    maara === 1 ? '1 kuittaamaton maininta' : `${maara} kuittaamatonta mainintaa`,
  'taulut.mainintaVihje': 'Kirjoita @ ja nimen alku mainitaksesi jäsenen.',
  'taulut.esikatsele': 'Esikatsele',
  'taulut.muokkaaKuvausta': 'Muokkaa kuvausta',
  'taulut.eiKuvausta': 'Ei kuvausta.',
  'taulut.muotoiluVihje': 'Markdown toimii, ja ```mermaid-lohko piirtyy kaaviona.',
  'taulut.mainintaEhdotukset': 'Jäsenet',
  'taulut.reagoi': 'Reagoi',
  'taulut.reaktio.THUMBS_UP': 'Samaa mieltä',
  'taulut.reaktio.CHECK': 'Tehty',
  'taulut.reaktio.EYES': 'Nähty',
  'taulut.reaktio.RED_FLAG': 'Kriittinen',
  'taulut.reaktionTiedot': (merkitys: string, nimet: string) => `${merkitys}: ${nimet}`,
  'taulut.tehtavaAgentilta': (lahde: string) => `Agentti loi tehtävän luojan nimissä (${lahde})`,
  'taulut.kaikkiTaulut': 'Kaikki taulut',
  'taulut.eiLoytynyt': 'Taulua ei löytynyt tai sinulla ei ole siihen pääsyä.',
  'taulut.uusiUimarata': 'Uusi uimarata',
  'taulut.uimaradanNimi': 'Integraation tai sovelluksen nimi',
  'taulut.lisaa': 'Lisää',
  'taulut.eiUimaratoja':
    'Taululla ei ole vielä uimaratoja. Lisää ensimmäinen — integraation tai sovelluksen nimi riittää.',
  'taulut.uimaradanToiminnot': 'Uimaradan toiminnot',
  'taulut.nimeaUimarata': 'Nimeä uimarata',
  'taulut.siirraVasemmalle': 'Siirrä uimarata vasemmalle',
  'taulut.siirraOikealle': 'Siirrä uimarata oikealle',
  'taulut.poistaUimarata': 'Poista uimarata',
  'taulut.poistetaankoUimarata': (nimi: string, maara: number) =>
    `Poistetaanko uimarata ”${nimi}” ja sen ${maara === 1 ? '1 tehtävä' : `${maara} tehtävää`}? Poistoa ei voi perua.`,
  'taulut.osio.INFO': 'INFO',
  'taulut.osio.TODO': 'TODO',
  'taulut.osio.DOING': 'DOING',
  'taulut.osio.BLOCKED': 'BLOCKED',
  'taulut.osio.IN_REVIEW': 'IN REVIEW',
  'taulut.osio.DONE': 'DONE',
  'taulut.osio.SKIPPED': 'SKIPPED',
  'taulut.tila.PLANNED': 'Suunniteltu',
  'taulut.tila.ACTIVE': 'Käynnissä',
  'taulut.tila.DONE': 'Valmis',
  'taulut.tila': 'Tila',
  'taulut.uimaradanTiedot': 'Uimaradan tiedot',
  'taulut.uimaradanTiedotSelite':
    'Arvio henkilötyöpäivinä puolikkaan tarkkuudella, aloitus ja suunniteltu valmistuminen sekä tila. Kirjatut henkilötyöpäivät lasketaan tehtäviin linkitetyistä kirjauksista.',
  'taulut.arvioHtp': 'Työmääräarvio (htp)',
  'taulut.aloitus': 'Aloitus',
  'taulut.valmistuminen': 'Suunniteltu valmistuminen',
  'taulut.lisaaTiedot': 'Lisää tiedot',
  'taulut.muokkaa': 'Muokkaa',
  'taulut.eiTietoja': 'Ei aikataulua eikä arviota',
  'taulut.htp': 'htp',
  'taulut.htpSelite': 'Kirjatut henkilötyöpäivät / työmääräarvio',
  'taulut.myohassa': 'myöhässä',
  'taulut.raportti': 'Raportti',
  'taulut.raporttiSelite': 'Tehtäväkohtainen erittely tilahistoriasta ja läpimenoaika',
  'taulut.milestone': 'Milestone',
  'taulut.milestonet': 'Milestonet',
  'taulut.muokkaaMilestoneja': 'Milestonet',
  'taulut.milestonetSelite':
    'Milestonet ovat uimaradan välietappeja, joihin tehtävät liitetään. Ne järjestyvät eräpäivän mukaan, ja seuraava saavuttamaton on korostettu. Saavutetuksi merkitset itse — tehtävien valmistuminen ei tee sitä automaattisesti.',
  'taulut.lisaaMilestone': 'Lisää milestone',
  'taulut.poistaMilestone': 'Poista milestone',
  'taulut.poistetaankoMilestone': (nimi: string, maara: number) =>
    `Poistetaanko milestone ”${nimi}”?${maara > 0 ? ` ${maara === 1 ? '1 tehtävä irrotetaan' : `${maara} tehtävää irrotetaan`} siitä, mutta tehtäviä ei poisteta.` : ''}`,
  'taulut.milestoneNimi': 'Nimi',
  'taulut.erapaiva': 'Eräpäivä',
  'taulut.erapaivaPvm': (pvm: string) => `Eräpäivä ${pvm}`,
  'taulut.eiErapaivaa': 'Ei eräpäivää',
  'taulut.milestoneKuvausVihje': 'Mitä milestonessa valmistuu (valinnainen)',
  'taulut.milestoneEdistyminen': (valmiit: number, kaikki: number) =>
    `${valmiit}/${kaikki} tehtävää valmiina`,
  'taulut.saavutettu': 'saavutettu',
  'taulut.saavutettuPvm': (pvm: string) => `Saavutettu ${pvm}`,
  'taulut.merkitseSaavutetuksi': 'Merkitse saavutetuksi',
  'taulut.palautaKeskeneraiseksi': 'Palauta keskeneräiseksi',
  'taulut.naytaSaavutetut': (maara: number) => `Saavutetut (${maara})`,
  'taulut.piilotaSaavutetut': 'Piilota saavutetut',
  'taulut.suodataMilestonella': (nimi: string) => `Näytä vain milestonen ”${nimi}” tehtävät`,
  'taulut.naytaKaikkiTehtavat': 'Näytä kaikki tehtävät',
  'taulut.milestoneKortilla': (nimi: string) => `Milestone: ${nimi}`,
  'taulut.eiMilestonea': 'Ei milestonea',
  'taulut.eiMilestonejaRadalla': 'Uimaradalla ei ole milestoneja',
  'taulut.deadline': 'Deadline',
  'taulut.deadlinePvm': (pvm: string) => `Deadline ${pvm}`,
  'taulut.deadlineModeraattorille': 'Deadlinen asettaa asiakasvastaava tai ylläpitäjä.',
  'taulut.deadlineMilestonenJalkeen': (pvm: string) =>
    `Deadline on milestonen eräpäivän (${pvm}) jälkeen.`,
  'taulut.deadlineAlkuperainen': (pvm: string, kertaa: number) =>
    `Alkuperäinen ${pvm} · siirretty ${kertaa === 1 ? 'kerran' : `${kertaa} kertaa`}`,
  'taulut.deadlineSiirretty': (mista: string, mihin: string) => `Deadline ${mista} → ${mihin}`,
  'taulut.deadlinePoistettu': (pvm: string) => `Deadline poistettu (oli ${pvm})`,
  'taulut.siirronSyy': 'Siirron syy',
  'taulut.siirronSyyEiKirjattu': 'Ei kirjattu',
  'taulut.siirronSyySelite':
    'Kenen takia deadline siirtyy? Toteumaa verrataan alkuperäiseen päivään.',
  'taulut.siirronSyy.OWN': 'Meidän puolemme',
  'taulut.siirronSyy.CUSTOMER': 'Asiakas',
  'taulut.siirronSyy.PARTNER': 'Kumppani',
  'taulut.vastuuMuutos': (nimi: string) => `Vastuu: ${nimi}`,
  'taulut.vainMyohassa': 'Myöhässä',
  'taulut.vainMyohassaSelite': 'Näytä vain avoimet tehtävät, joiden deadline on mennyt',
  'taulut.milestoneIrtoaa':
    'Siirto toiselle uimaradalle irrottaa tehtävän nykyisestä milestonesta.',
  'taulut.milestoneKirjattu': (tunnit: string) => `kirjattu ${tunnit}`,
  'taulut.milestoneKirjattuSelite':
    'Milestoneen liitettyihin tehtäviin kirjatut tunnit näkyvyysalueellasi.',
  'taulut.seuraavaMilestone': (nimi: string, pvm: string) => `Seuraava milestone: ${nimi} (${pvm})`,
  'taulut.seuraavaMilestoneLyhyt': 'Seuraava milestone',
  'taulut.ganttMilestone.kesken': 'Milestone',
  'taulut.ganttMilestone.saavutettu': 'Saavutettu milestone',
  'taulut.ganttMilestone.myohassa': 'Myöhässä oleva milestone',
  'taulut.ganttMilestoneVihje': (nimi: string, pvm: string) => `${nimi}, eräpäivä ${pvm}`,
  'taulut.rajaaTehtavia': 'Rajaa tehtäviä',
  'taulut.haeTehtavista': 'Hae tehtävistä',
  'taulut.kaikkiVastuuhenkilot': 'Kaikki vastuuhenkilöt',
  'taulut.vainOmat': 'Vain omat',
  'taulut.rajausTulos': (nakyvia: number, kaikki: number) =>
    `Näytetään ${nakyvia}/${kaikki} tehtävää`,
  'taulut.tyhjennaRajaus': 'Tyhjennä rajaus',
  'taulut.taulu': 'Taulu',
  'taulut.tamaTaulu': 'Tämä taulu',
  'taulut.siirtoTaululleVihje':
    'Tehtävä siirtyy saman asiakkuuden toiselle taululle. Milestone irtoaa, kommentit, relaatiot ja kirjaukset säilyvät.',
  'taulut.kohdetaulullaEiUimaratoja': 'Kohdetaululla ei ole uimaratoja.',
  'taulut.siirrettyTaululle': (taulu: string) => `Tehtävä siirretty tauluun ${taulu}.`,
  'taulut.asetusMilestone': 'Muistutus milestonen eräpäivästä',
  'taulut.asetusMilestoneSelite':
    'Milestonen luojalle ja asiakasvastaaville, kun saavuttamattoman milestonen eräpäivään on kolme päivää, ja viikoittain, kun se on myöhässä.',
  'asiakasraportti.avaa': 'Asiakasraportti',
  'asiakasraportti.avaaSelite': 'Tilannekatsaus asiakkaalle Markdownina',
  'asiakasraportti.otsikko': 'Asiakasraportti',
  'asiakasraportti.selite':
    'Tilannekatsaus asiakkaalle lähetettäväksi: uimaradat, milestonet, seuraavan milestonen keskeneräiset ja odottavat tehtävät sekä jakson aikana valmistuneet. Kuvaukset, kommentit, vastuuhenkilöt ja INFO-osion tehtävät eivät ole mukana.',
  'asiakasraportti.laajuus': 'Laajuus',
  'asiakasraportti.tamaTaulu': 'Tämä taulu',
  'asiakasraportti.kaikkiTaulut': (asiakas: string) => `Kaikki asiakkaan ${asiakas} taulut`,
  'asiakasraportti.valmistuneet': 'Valmistuneet',
  'asiakasraportti.paivaa': (paivia: number) => `${paivia} päivää`,
  'asiakasraportti.kieli': 'Kieli',
  'asiakasraportti.suomi': 'Suomi',
  'asiakasraportti.englanti': 'English',
  'asiakasraportti.tunnit': 'Näytä kirjatut tunnit',
  'asiakasraportti.tunnitSelite':
    'Uimaradoille ja milestoneille kirjatut tunnit. Valitse vain, jos sopimus edellyttää niiden kertomista asiakkaalle.',
  'asiakasraportti.nakyma': 'Näkymä',
  'asiakasraportti.esikatselu': 'Esikatselu',
  'asiakasraportti.markdownTeksti': 'Raportti Markdown-tekstinä',
  'asiakasraportti.tarkista':
    'Lue raportti ennen lähettämistä: tehtävien otsikot ovat siinä sellaisinaan.',
  'asiakasraportti.kopioi': 'Kopioi',
  'asiakasraportti.kopioitu': 'Kopioitu',
  'asiakasraportti.lataa': 'Lataa .md',
  'taulut.takaisinTaululle': 'Takaisin taululle',
  'taulut.lataaCsv': 'Lataa CSV',
  'taulut.aikataulu': 'Aikataulu',
  'taulut.lapimenoaika': 'Läpimenoaika',
  'taulut.alkaen': (alku: string) => `alkaen ${alku}`,
  'taulut.eiValmis': 'ei vielä valmis',
  'taulut.jumissaNyt': 'Jumissa nyt',
  'taulut.vastuuhenkilo': 'Vastuuhenkilö',
  'taulut.lisatty': 'Lisätty',
  'taulut.paattynyt': 'Päättynyt',
  'taulut.siirtymia': 'Siirtymiä',
  'taulut.eiTehtavia': 'Uimaradalla ei ole tehtäviä.',
  'taulut.raporttiHuomio': (aika: string) =>
    `Kestot ovat kalenteriaikaa, eivät työpäiviä; avoimen osion kesto on laskettu hetkeen ${aika}.`,
  'taulut.tilahistoria': 'Tilahistoria',
  'taulut.tapahtumat': (maara: number) => `${maara} tapahtumaa`,
  'taulut.kestoMinuutit': (min: number) => `${min} min`,
  'taulut.kestoTunnit': (h: number) => `${String(h).replace('.', ',')} h`,
  'taulut.kestoPaivat': (pv: number) => `${String(pv).replace('.', ',')} pv`,
  'taulut.ruuhka': (maara: number) =>
    `${maara} tehtävää DOING-osiossa samalle vastuuhenkilölle — enemmän kuin kolme kerrallaan harvoin valmistuu.`,
  'taulut.ruuhkaTaululla': 'Yli kolme tehtävää käynnissä tällä taululla',
  'taulut.omatTehtavat': 'Omat tehtävät',
  'taulut.gantt': 'Gantt',
  'taulut.ganttSelite':
    'Kaikki uimaradat aikajanalla aloitus- ja valmistumispäivän mukaan. Purppura jakso palkin alareunassa on pisimpään jumissa olleen tehtävän aika; luku palkin päässä on jumissa olevien määrä.',
  'taulut.naytaValmiit': 'Näytä myös valmiit',
  'taulut.selite': 'Selite',
  'taulut.ganttJumissaSelite': 'Jumissa (pisin jakso)',
  'taulut.eiAjoitettuja': 'Yhdelläkään uimaradalla ei ole aloitus- ja valmistumispäivää.',
  'taulut.ilmanAikataulua': 'Ilman aikataulua',
  'taulut.vk': (n: number) => `vk ${n}`,
  'taulut.jumissaMaara': (n: number) => (n === 1 ? '1 tehtävä jumissa' : `${n} tehtävää jumissa`),
  'taulut.tehtaviaValmiina': (valmis: number, kaikki: number) =>
    `${valmis}/${kaikki} tehtävää päättynyt`,
  'taulut.ganttJumissaVihje': (otsikko: string, pv: number) =>
    `Jumissa pisimpään: ${otsikko}, ${pv} pv`,
  'taulut.ganttHuomio': (pvm: string) =>
    `Pystyviiva on tämä päivä (${pvm}). Uimaradan nimi avaa raportin, asiakkaan nimi taulun.`,
  'taulut.vastuuAsiakas': 'Asiakas',
  'taulut.vastuuKumppani': 'Kumppani',
  'taulut.asiakkaanHenkilo': (nimi: string) => `${nimi} (asiakas)`,
  'taulut.asiakasTasolla': 'Asiakas, ei henkilöä',
  'taulut.odottaaUlkoista': (nimi: string) => `Odottaa: ${nimi}`,
  'taulut.ulkoinenVastuuSelite':
    'Tehtävä odottaa asiakasta tai kumppania. Heille ei lähde ilmoituksia, eikä agentti siirrä tehtävää.',
  'kumppanit.otsikko': 'Kumppanit',
  'kumppanit.selite':
    'Toimittajat ja integraatiokumppanit, joiden vastuulle tehtävän voi osoittaa. Rekisteri on yhteinen kaikille asiakkuuksille.',
  'kumppanit.uusi': 'Uusi kumppani',
  'kumppanit.muokkaa': 'Muokkaa kumppania',
  'kumppanit.kuvaus': 'Kuvaus',
  'kumppanit.kuvausVihje': 'Mitä kumppani tekee ja minkä asiakkuuksien kanssa.',
  'kumppanit.eiKumppaneita': 'Rekisterissä ei ole kumppaneita.',
  'kumppanit.passivoitu': 'passivoitu',
  'kumppanit.passivoi': 'Passivoi',
  'kumppanit.aktivoi': 'Aktivoi',
  'kumppanit.avoimiaTehtavia': (maara: number) =>
    maara === 1 ? '1 avoin tehtävä' : `${maara} avointa tehtävää`,
  'kumppanit.poistaVahvistus': (nimi: string) => `Poistetaanko kumppani ${nimi}?`,
  'kumppanit.naytaPassivoidut': (maara: number) => `Näytä passivoidut (${maara})`,
  'jumissa.otsikko': 'Jumissa',
  'jumissa.selite': (raja: number) =>
    `Kaikki BLOCKED-osiossa olevat tehtävät tauluiltasi, pisimpään jumissa ollut ensin. Punainen luku on yli ${raja} päivää — samalla rajalla lähtee sähköpostimuistutus. Suljettujen projektien ja passivoitujen asiakkaiden tauluja ei näytetä.`,
  'jumissa.eiJumissa': 'Yksikään tehtävä ei ole jumissa tauluillasi.',
  'jumissa.rajaus': 'Rajaus',
  'jumissa.kaikki': 'Jumissa yhteensä',
  'jumissa.kaikkiVihje': 'Näytä kaikki jumissa olevat',
  'jumissa.yliRajan': (raja: number) => `Yli ${raja} päivää`,
  'jumissa.yliRajanVihje': 'Jumissa niin kauan, että muistutus on jo lähtenyt',
  'jumissa.hiljaa': 'Ilman selitystä',
  'jumissa.hiljaaVihje': 'Kukaan ei ole kommentoinut tehtävää sen jälkeen, kun se siirtyi jumiin',
  'jumissa.odottaa': 'Odottaa toista tehtävää',
  'jumissa.odottaaVihje': 'Tehtävä riippuu keskeneräisestä tehtävästä',
  'jumissa.asiakkaittain': 'Asiakkaittain',
  'jumissa.kaikkiAsiakkaat': 'Kaikki asiakkaat',
  'jumissa.haku': 'Hae tehtävää, uimarataa, asiakasta tai henkilöä',
  'jumissa.jarjestys': 'Järjestys',
  'jumissa.jarjestysJumissa': 'Pisimpään jumissa',
  'jumissa.jarjestysHiljaa': 'Pisimpään hiljaa',
  'jumissa.jarjestysAsiakas': 'Asiakkaan mukaan',
  'jumissa.jarjestysMilestone': 'Seuraavan milestonen mukaan',
  'jumissa.milestone': 'Jarruttaa milestonea',
  'jumissa.milestoneVihje': 'Tehtävä kuuluu uimaradan seuraavaan saavuttamattomaan milestoneen',
  'jumissa.jarruttaaMilestonea': 'seuraava milestone',
  'jumissa.kopioi': 'Kopioi lista',
  'jumissa.kopioiVihje': 'Kopioi näkyvät tehtävät tekstinä palaveriin tai viestiin',
  'jumissa.kopioitu': 'Kopioitu',
  'jumissa.kopioRivi': (paivia: number, vastuu: string) =>
    `jumissa ${paivia} pv, vastuu: ${vastuu}`,
  'jumissa.kopioViimeisin': (nimi: string, aika: string) => `Viimeisin kommentti ${nimi} ${aika}`,
  'jumissa.eiOsumia': 'Rajaus ei jätä yhtään tehtävää.',
  'jumissa.nakyvissa': (nakyvat: number, kaikki: number) =>
    `${nakyvat}/${kaikki} jumissa olevaa tehtävää näkyvissä.`,
  'jumissa.nakyvissaAsiakas': (nakyvat: number, asiakas: string) =>
    `${nakyvat} tehtävää näkyvissä asiakkaalta ${asiakas}.`,
  'jumissa.pvJumissa': 'pv jumissa',
  'jumissa.jumissaAlkaen': (aika: string) => `Jumissa ${aika} alkaen`,
  'jumissa.siirsi': (nimi: string, aika: string) => `Jumiin siirsi ${nimi} ${aika}`,
  'jumissa.kerta': (kerta: number) => `${kerta}. kerta jumissa`,
  'jumissa.toistuvaVihje':
    'Tehtävä on ollut BLOCKED-osiossa aiemminkin — toistuva jumi voi kertoa rakenteellisesta esteestä.',
  'jumissa.odottaaTehtavaa': 'Odottaa:',
  'jumissa.eiKommenttiaJalkeen': 'Ei kommenttia jumiin siirron jälkeen — syy ei näy taululla.',
  'jumissa.ennenJumiutumista': 'ennen jumiutumista',
  'jumissa.tanaan': 'tänään',
  'jumissa.eilen': 'eilen',
  'jumissa.paivaaSitten': (paivia: number) => `${paivia} pv sitten`,
  'jumissa.ganttLinkki': 'Näytä jumissa olevat tehtävät',
  'taulut.omatSelite':
    'Sinulle osoitetut avoimet tehtävät kaikilta tauluiltasi, käynnissä olevat ensin. Klikkaus avaa tehtävän taululla.',
  'taulut.eiOmiaTehtavia': 'Sinulle ei ole osoitettu avoimia tehtäviä.',
  'taulut.aiTehtavat': 'AI-assistentille osoitetut',
  'taulut.aiTehtavatSelite':
    'Tehtävät, jotka on tarkoitettu agentin poimittavaksi tauluillasi. Agenttisi näkee saman listan my_tasks-työkalulla.',
  'taulut.eiAiTehtavia': 'AI-assistentille ei ole osoitettu avoimia tehtäviä.',
  'taulut.naytaKaikki': (maara: number) => `Näytä kaikki (${maara})`,
  'taulut.naytaVahemman': 'Näytä vähemmän',
  'taulut.ohitaTehtava': 'Jätetään toteuttamatta',
  'taulut.ohitaSelite':
    'Tehtävä siirtyy SKIPPED-osioon. Kirjoita, miksi sitä ei toteuteta — perustelu tallentuu tehtävän kommenttina.',
  'taulut.ohitusPerustelu': 'Miksi ei toteuteta',
  'taulut.ohitusPerusteluVihje': 'esim. analyysi osoitti, että nykyinen toteutus riittää',
  'taulut.ohitusPerusteluPuuttuu': 'SKIPPED-osioon siirto vaatii perustelun.',
  'taulut.ohita': 'Siirrä SKIPPED-osioon',
  'taulut.ohitettu': 'Tehtävä merkitty toteuttamatta jätettäväksi.',
  'taulut.lisaaTehtava': (osio: string) => `Lisää tehtävä osioon ${osio}`,
  'taulut.tehtavanOtsikko': 'Tehtävän otsikko',
  'taulut.avaaTehtava': 'Avaa tehtävä',
  'taulut.tehtava': 'Tehtävä',
  'taulut.monistaTehtava': 'Monista tehtävä samaan osioon',
  'taulut.poistaTehtava': 'Poista tehtävä',
  'taulut.poistetaankoTehtava': 'Poistetaanko tehtävä? Poistoa ei voi perua.',
  'taulut.otsikkoKentta': 'Otsikko',
  'taulut.kuvaus': 'Kuvaus',
  'taulut.tyomaara': 'Työmääräarvio',
  'taulut.eiArviota': 'Ei arviota',
  'taulut.eiVastuuhenkiloa': 'Ei vastuuhenkilöä',
  'taulut.aiAssistentti': 'AI-assistentti',
  'taulut.uimarata': 'Uimarata',
  'taulut.osio': 'Osio',
  'taulut.jumissa': (paivaa: number) => `Jumissa ${paivaa} päivää`,
  'taulut.luonut': (nimi: string) => `Luonut ${nimi}`,
  'taulut.eiMuokkausoikeutta':
    'Voit siirtää tehtävän, mutta sen sisältöä muokkaa vain sen luoja, asiakasvastaava tai ylläpitäjä.',
  'taulut.kommentit': 'Kommentit',
  'taulut.kommentitSelite':
    'Mitä tehtävässä on tehty tai huomattu. Aika kirjataan tuntikirjanpitoon, ei tänne.',
  'taulut.eiKommentteja': 'Ei vielä kommentteja.',
  'taulut.kommentteja': (maara: number) => (maara === 1 ? '1 kommentti' : `${maara} kommenttia`),
  'taulut.uusiKommentti': 'Uusi kommentti',
  'taulut.kommentinVihje': 'Mitä teit tai huomasit? @ mainitsee jäsenen, Ctrl+Enter lähettää.',
  'taulut.lisaaKommentti': 'Lisää kommentti',
  'taulut.muokkaaKommenttia': 'Muokkaa kommenttia',
  'taulut.poistaKommentti': 'Poista kommentti',
  'taulut.poistetaankoKommentti': 'Poistetaanko kommentti? Poistoa ei voi perua.',
  'taulut.muokattu': 'muokattu',
  'taulut.kommenttiAgentilta': (lahde: string) =>
    `Agentti kirjoitti kirjoittajan nimissä (${lahde})`,
  'taulut.monistettu': 'Tehtävä monistettu.',
  'taulut.siirretty': 'Tehtävä siirretty.',
  'taulut.toimintoEpaonnistui': 'Toiminto epäonnistui.',
  'taulut.ohje':
    'Raahaus siirtää tehtävän toiseen osioon tai uimarataan; Ctrl, Alt tai Cmd pohjassa raahattu tehtävä monistuu. Näppäimistöltä sama tehdään avaamalla tehtävä ja vaihtamalla uimarata tai osio. Huutomerkki tarkoittaa, että tehtävä on ollut BLOCKED-osiossa yli 8 vuorokautta.',

  // --- Asiakkaan tiedot: kuvaus, yhteyshenkilöt, linkit (suunnitelma 8) ----
  'asiakastiedot.kuvaus': 'Kuvaus',
  'asiakastiedot.kuvausTyhja': 'Ei kuvausta.',
  'asiakastiedot.kuvausVihje': 'Markdown käy: otsikot, listat, lihavointi ja linkit.',
  'asiakastiedot.yhteyshenkilot': 'Yhteyshenkilöt',
  'asiakastiedot.eiYhteyshenkiloita': 'Ei yhteyshenkilöitä.',
  'asiakastiedot.uusiYhteyshenkilo': 'Uusi yhteyshenkilö',
  'asiakastiedot.muokkaaYhteyshenkiloa': 'Muokkaa yhteyshenkilöä',
  'asiakastiedot.poistaYhteyshenkilo': (nimi: string) => `Poistetaanko yhteyshenkilö ${nimi}?`,
  'asiakastiedot.nimi': 'Nimi',
  'asiakastiedot.rooli': 'Rooli asiakkaalla',
  'asiakastiedot.roolinVihje': 'Esimerkiksi talouspäällikkö tai tekninen yhteyshenkilö.',
  'asiakastiedot.sahkoposti': 'Sähköposti',
  'asiakastiedot.puhelin': 'Puhelin',
  'asiakastiedot.huomio': 'Huomio',
  'asiakastiedot.huomionVihje': 'Tavoitettavuus, vastuualue tai muu, joka kannattaa muistaa.',
  'asiakastiedot.ensisijainen': 'Ensisijainen yhteyshenkilö',
  'asiakastiedot.ensisijainenSelite': ' — korvaa aiemman valinnan',
  'asiakastiedot.ensisijainenMerkki': 'Ensisijainen',
  'asiakastiedot.linkit': 'Dokumentit',
  'asiakastiedot.eiLinkkeja': 'Ei dokumenttilinkkejä.',
  'asiakastiedot.uusiLinkki': 'Uusi linkki',
  'asiakastiedot.muokkaaLinkkia': 'Muokkaa linkkiä',
  'asiakastiedot.poistaLinkki': (nimi: string) => `Poistetaanko linkki ${nimi}?`,
  'asiakastiedot.nimilappu': 'Nimilappu',
  'asiakastiedot.nimilapunVihje': 'Mitä dokumentti on, esimerkiksi ”Sopimus 2026”.',
  'asiakastiedot.osoite': 'Osoite',
  'asiakastiedot.osoitteenVihje': 'Vain http- ja https-osoitteet.',
  'asiakastiedot.tagit': 'Tagit',
  'asiakastiedot.tagienVihje': 'Enter lisää tagin. Ehdotukset ovat talossa jo käytössä.',
  'asiakastiedot.lisaaTagi': 'Lisää tagi',
  'asiakastiedot.poistaTagi': (tagi: string) => `Poista tagi ${tagi}`,
  'asiakastiedot.tagejaEnintaan': (maara: number) => `Tageja voi olla enintään ${maara}.`,
  'asiakastiedot.siirraYlos': 'Siirrä ylös',
  'asiakastiedot.siirraAlas': 'Siirrä alas',
  'asiakastiedot.avaaUudessa': 'Avautuu uuteen välilehteen',
  'asiakastiedot.sisainenEiYhteyshenkiloita':
    'Sisäisellä asiakkaalla ei ole yhteyshenkilöitä — se on tuntikirjanpidon apukäsite, ei asiakkuus.',
  'asiakastiedot.eiOikeutta':
    'Vain ylläpitäjä ja asiakkaan asiakasvastaava voivat muokata näitä tietoja.',
  'asiakastiedot.otsikko': (nimi: string) => `Asiakkaan tiedot · ${nimi}`,
  'asiakastiedot.avaaTiedot': 'Asiakkaan tiedot',

  // --- Kehitys ja osaaminen (docs/KEHITYSSUUNNITELMAT.md) --------------------
  'navi.kehitys': 'Kehitys',
  'kehitys.otsikko': 'Oma kehitys',
  'kehitys.selite':
    'Suoritetut sertifikaatit ja niiden voimassaolo. Esihenkilö vahvistaa saavutuksen, ja vasta vahvistettu näkyy talon osaamisraportissa.',
  'kehitys.esihenkilo': 'Esihenkilö',
  'kehitys.eiEsihenkiloa': 'Esihenkilöä ei ole asetettu. Pyydä ylläpitäjää lisäämään se.',
  'kehitys.sertifikaatit': 'Sertifikaatit',
  'kehitys.eiSertifikaatteja': 'Ei kirjattuja sertifikaatteja.',
  'kehitys.kirjaaSaavutus': 'Kirjaa sertifikaatti',
  'kehitys.sertifikaatti': 'Sertifikaatti',
  'kehitys.suoritettu': 'Suoritettu',
  'kehitys.voimassaAsti': 'Voimassa asti',
  'kehitys.eiVanhene': 'Ei vanhene',
  'kehitys.todistuslinkki': 'Todistuslinkki',
  'kehitys.todistuslinkkiVihje':
    'Osoite tarjoajan todistukseen, esimerkiksi Credly tai Microsoft Learn.',
  'kehitys.huomio': 'Huomio',
  'kehitys.vanhenemisVihje': 'Jätä tyhjäksi, niin päivä lasketaan luettelon voimassaolosta.',
  'kehitys.omaVanheneminen': 'Anna vanhenemispäivä itse',
  'kehitys.eiVanheneValinta': 'Tämä suoritus ei vanhene',
  'kehitys.tila.VOIMASSA': 'Voimassa',
  'kehitys.tila.VANHENEMASSA': 'Vanhenemassa',
  'kehitys.tila.VANHENTUNUT': 'Vanhentunut',
  'kehitys.odottaaVahvistusta': 'Odottaa vahvistusta',
  'kehitys.vahvista': 'Vahvista',
  'kehitys.vahvistanut': (nimi: string) => `Vahvistanut ${nimi}`,
  'kehitys.kirjannut': (nimi: string) => `Kirjannut ${nimi}`,
  'kehitys.alaiset': 'Alaiset',
  'kehitys.alaisetSelite': 'Henkilöt, joiden kanssa käyt kehityskeskustelut.',
  'kehitys.voimassaMaara': (maara: number) => `${maara} voimassa`,
  'kehitys.odottaaMaara': (maara: number) => `${maara} odottaa vahvistusta`,
  'kehitys.vanheneeMaara': (maara: number) => `${maara} vanhenemassa`,
  'kehitys.avaaHenkilo': 'Avaa',
  'kehitys.paluuOmaan': 'Takaisin omaan kehitykseen',
  'kehitys.henkilonOtsikko': (nimi: string) => `Kehitys · ${nimi}`,
  'kehitys.passivoitu': 'passivoitu',
  'kehitys.eiVoiVahvistaaItse': 'Omaa saavutusta ei voi vahvistaa itse.',

  'osaaminen.otsikko': 'Osaaminen',
  'osaaminen.luettelo': 'Sertifikaattiluettelo',
  'osaaminen.luetteloSelite':
    'Mitä talossa voi saavuttaa. Rivi passivoidaan, ei poisteta — sillä voi olla saavutuksia.',
  'osaaminen.matriisi': 'Osaamismatriisi',
  'osaaminen.matriisiSelite':
    'Vahvistetut saavutukset henkilöittäin. Tämä on se näkymä, joka avataan tarjouksen liitettä varten.',
  'osaaminen.uusiSertifikaatti': 'Uusi sertifikaatti',
  'osaaminen.koodi': 'Koodi',
  'osaaminen.nimi': 'Nimi',
  'osaaminen.tarjoaja': 'Tarjoaja',
  'osaaminen.voimassaoloKuukautta': 'Voimassaolo (kk)',
  'osaaminen.osoite': 'Osoite',
  'osaaminen.saavutuksia': 'Saavutuksia',
  'osaaminen.aktiivinen': 'Käytössä',
  'osaaminen.passivoi': 'Passivoi',
  'osaaminen.otaKayttoon': 'Ota käyttöön',
  'osaaminen.eiSertifikaatteja': 'Luettelo on tyhjä. Lisää ensimmäinen sertifikaatti.',
  'osaaminen.eiSaavutuksia': 'Yhtään vahvistettua saavutusta ei ole.',
  'osaaminen.kaikkiTarjoajat': 'Kaikki tarjoajat',
  'osaaminen.kaikkiSertifikaatit': 'Kaikki sertifikaatit',
  'osaaminen.vainVoimassa': 'Vain voimassa olevat',
  'osaaminen.myosPassivoidut': 'Myös passivoidut henkilöt',
  'osaaminen.vieCsv': 'Vie CSV',
  'osaaminen.voimassaYhteensa': (maara: number) => `${maara} henkilöllä voimassa`,
  'osaaminen.koodiVihje': 'Tarjoajan tunniste, esimerkiksi AZ-104 tai SAA-C03.',
  'osaaminen.voimassaoloVihje': 'Tyhjä = ei vanhene.',
  'osaaminen.koodista': 'koodista',
  'osaaminen.koodistaVihje':
    'Tiedot tulevat kehityspolkuluettelosta koodista. Muuta ne siellä ja aja pnpm polut:sync — täältä rivin voi vain passivoida.',
  'osaaminen.koodiaEiVoiMuuttaa':
    'Koodia ei voi muuttaa. Väärä koodi korjataan passivoimalla rivi ja luomalla oikea.',

  // --- Kehityspolut (docs/KEHITYSSUUNNITELMAT.md, luku 16) -----------------
  'polut.otsikko': 'Kehityspolut',
  'polut.selite':
    'Valmiita polkuja sertifiointiin: mitä kannattaa tehdä ensin, mitä se vaatii ja paljonko siihen menee aikaa. Selaaminen ei sido mihinkään.',
  'polut.eiPolkuja': 'Polkuja ei ole vielä määritelty.',
  'polut.paluuKehitykseen': 'Takaisin omaan kehitykseen',
  'polut.kaikkiPolut': 'Kaikki kehityspolut',
  'polut.eiLoytynyt': 'Polkua ei löytynyt. Se on voitu poistaa luettelosta.',
  'polut.selaaPolkuja': 'Selaa kehityspolkuja',
  'polut.askelia': (maara: number) => `${maara} askelta`,
  'polut.askeleet': 'Askeleita',
  'polut.kuormitus': 'Arvioitu kuormitus',
  'polut.omaEteneminen': 'Oma eteneminen',
  'polut.tunnit': (tunnit: number) => `noin ${tunnit} h`,
  'polut.tunnitYhteensa': (tunnit: number) => `noin ${tunnit} h yhteensä`,
  'polut.eteneminen': (tehty: number, kaikki: number) => `${tehty}/${kaikki} suoritettu`,
  'polut.rooli.REQUIRED': 'Polun ydin',
  'polut.rooli.RECOMMENDED': 'Suositeltu',
  'polut.rooli.OPTIONAL': 'Jatko',
  'polut.tila.SUORITETTU': 'Suoritettu',
  'polut.tila.TAVOITTEENA': 'Tavoitteena',
  'polut.tila.EI_ALOITETTU': 'Ei aloitettu',
  'polut.tenttiversio': (koodi: string) => `tentti ${koodi}`,
  'polut.tavoiteOtsikko': (koodi: string) => `${koodi} suoritettuna`,
  'polut.tenttimaksu': (maara: number, valuutta: string) => `tentti ${maara} ${valuutta}`,
  'polut.hintaTarjoajalta': 'hinta tarjoajan sivulla',
  'polut.tarjoajanSivu': 'Tarjoajan sivu',
  'polut.edellyttaa': (nimet: string) => `Edellyttää: ${nimet}`,
  'polut.asetaTavoitteeksi': 'Aseta tavoitteeksi',
  'polut.valmisSertifikaatti': (koodi: string) => `${koodi}-tentti läpäisty ja todistus saatu.`,
  'polut.valmisKoulutus': (nimi: string) => `Koulutus ”${nimi}” suoritettu hyväksytysti.`,
  'polut.valmisMateriaali': (nimi: string) => `Materiaali ”${nimi}” käyty läpi.`,
  'polut.linkkiVihje':
    'Vaatimukset, tenttialueet ja hinnat ovat tarjoajan omilla sivuilla — sieltä ne ovat ajan tasalla. Tällä sivulla on järjestys, perustelu ja aika-arvio.',
  'polut.yllapitoVihje':
    'Polut ylläpidetään koodissa, jotta muutos on katselmoitavissa. Kerro ylläpitäjälle, jos jokin askel on vanhentunut tai polku puuttuu.',

  'kayttajat.esihenkilo': 'Esihenkilö',
  'kayttajat.eiEsihenkiloa': 'Ei esihenkilöä',
  'kayttajat.esihenkiloVihje':
    'Esihenkilö näkee tämän henkilön kehityssuunnitelman ja saa muistutuksen kehityskeskustelusta.',

  // --- Kehityssuunnitelma (docs/KEHITYSSUUNNITELMAT.md, luvut 7–8) ---------
  'kehitys.suunta': 'Suunta',
  'kehitys.suuntaVihje':
    'Pidemmän aikavälin suunta, jonka alle tavoitteet asettuvat. Kirjoittaa esihenkilö.',
  'kehitys.eiSuuntaa': 'Suuntaa ei ole kirjattu.',
  'kehitys.muokkaaSuuntaa': 'Muokkaa suuntaa',
  'kehitys.tavoitteet': 'Tavoitteet',
  'kehitys.eiTavoitteita': 'Ei tavoitteita. Lisää ensimmäinen.',
  'kehitys.uusiTavoite': 'Uusi tavoite',
  'kehitys.muokkaaTavoitetta': 'Muokkaa tavoitetta',
  'kehitys.tavoiteOtsikko': 'Tavoite',
  'kehitys.tavoiteOtsikkoVihje': 'Esimerkiksi ”AZ-104 suoritettuna”.',
  'kehitys.valmiinMaaritelma': 'Mistä tiedämme, että tämä on valmis?',
  'kehitys.valmiinMaaritelmaVihje':
    'Ilman tätä puolen vuoden päästä käytävä keskustelu on keskustelu fiiliksestä.',
  'kehitys.tavoitepaiva': 'Tavoitepäivä',
  'kehitys.kuvaus': 'Kuvaus',
  'kehitys.kohde': 'Liittyy',
  'kehitys.eiKohdetta': 'Ei sertifikaattia eikä koulutusta',
  'kehitys.kohdeSertifikaatti': 'Sertifikaatti',
  'kehitys.kohdeKoulutus': 'Talon koulutus',
  'kehitys.tavoiteTila.PLANNED': 'Suunniteltu',
  'kehitys.tavoiteTila.IN_PROGRESS': 'Käynnissä',
  'kehitys.tavoiteTila.ACHIEVED': 'Saavutettu',
  'kehitys.tavoiteTila.DROPPED': 'Hylätty',
  'kehitys.myohassa': 'Myöhässä',
  'kehitys.merkitseSaavutetuksi': 'Merkitse saavutetuksi',
  'kehitys.hylkaa': 'Hylkää',
  'kehitys.hylkaysSyy': 'Miksi tavoite hylätään?',
  'kehitys.poistaTavoite': 'Poista',
  'kehitys.saavutettu': (paiva: string) => `Saavutettu ${paiva}`,
  'kehitys.edellinenKeskustelu': (paiva: string) => `Edellinen keskustelu ${paiva}`,
  'kehitys.eiKeskusteltu': 'Tästä ei ole vielä keskusteltu.',

  'kehitys.keskustelut': 'Keskustelut',
  'kehitys.eiKeskusteluja': 'Kehityskeskusteluja ei ole vielä käyty.',
  'kehitys.aloitaKeskustelu': 'Aloita keskustelu',
  'kehitys.jatkaKeskustelua': 'Jatka keskustelua',
  'kehitys.avoinKeskustelu': 'Avoin keskustelu',
  'kehitys.keskustelunPaiva': 'Keskustelun päivä',
  'kehitys.seuraavaKeskustelu': 'Seuraava keskustelu',
  'kehitys.seuraavaEraantyy': (paiva: string) => `Seuraava keskustelu ${paiva}`,
  'kehitys.seuraavaEraantynyt': (paiva: string) => `Seuraava keskustelu oli ${paiva}`,
  'kehitys.yhteenveto': 'Mitä sovittiin',
  'kehitys.yhteenvetoVihje': 'Näkyy työntekijälle. Markdown käytössä.',
  'kehitys.suljeKeskustelu': 'Sulje keskustelu',
  'kehitys.suljettu': (paiva: string) => `Suljettu ${paiva}`,
  'kehitys.suljettuVaroitus':
    'Suljettua keskustelua ei voi enää muuttaa. Korjaus kirjataan seuraavaan keskusteluun.',
  'kehitys.poistaKeskustelu': 'Poista keskustelu',
  'kehitys.puuttuuKirjauksia': (maara: number) =>
    maara === 1 ? '1 tavoite ilman kirjausta' : `${maara} tavoitetta ilman kirjausta`,
  'kehitys.kaikkiKirjattu': 'Kaikki tavoitteet kirjattu.',
  'kehitys.tamanKeskustelunKirjaus': 'Tämän keskustelun kirjaus',
  'kehitys.valitseTavoite': 'Valitse tavoite vasemmalta.',
  'kehitys.kommentti': 'Mitä tästä todettiin?',
  'kehitys.suljetutTavoitteet': 'Valmistuneet ja hylätyt',
  'kehitys.kirjattu': 'Kirjattu',
  'kehitys.tavoitteitaKasitelty': (maara: number) => `${maara} tavoitetta`,
  'kehitys.keskusteluaEiLoytynyt': 'Keskustelua ei löytynyt.',
  'kehitys.avaaKeskustelu': 'Avaa',
  'kehitys.avoimiaTavoitteita': (maara: number) => `${maara} tavoitetta auki`,
  'kehitys.myohassaMaara': (maara: number) => `${maara} myöhässä`,
  'kehitys.keskusteluEraantynyt': 'Keskustelu erääntynyt',
  'kehitys.paluuSuunnitelmaan': 'Takaisin suunnitelmaan',
  'kehitys.vainEsihenkilo': 'Keskustelun aloittaa ja sulkee esihenkilö.',
  'kehitysKatsaus.otsikko': 'Kehityskeskustelut',
  'kehitysKatsaus.selite':
    'Kenellä on esihenkilö, milloin keskusteltiin viimeksi ja mikä on myöhässä. Näkymässä ei ole keskustelujen sisältöä.',
  'kehitysKatsaus.henkilo': 'Henkilö',
  'kehitysKatsaus.esihenkilo': 'Esihenkilö',
  'kehitysKatsaus.viimeksi': 'Viimeksi',
  'kehitysKatsaus.seuraava': 'Seuraava',
  'kehitysKatsaus.tavoitteet': 'Tavoitteita',
  'kehitysKatsaus.sertifikaatit': 'Sertifikaatteja',
  'kehitysKatsaus.eiEsihenkiloa': 'Ei esihenkilöä',
  'kehitysKatsaus.eiKeskusteltu': 'Ei koskaan',
  'kehitysKatsaus.eraantynyt': 'Erääntynyt',
  'kehitysKatsaus.avoinKeskustelu': 'Keskustelu käynnissä',
  'kehitysKatsaus.henkiloita': 'Henkilöitä',
  'kehitysKatsaus.ilmanEsihenkiloa': 'Ilman esihenkilöä',
  'kehitysKatsaus.eraantyneita': 'Erääntyneitä',
  'kehitysKatsaus.eiKoskaanKeskusteltu': 'Ei yhtään keskustelua',
  'kehitysKatsaus.tyhja': 'Ei seurattavia henkilöitä.',
  'asetukset.sailytysaika': 'Kehityskeskustelujen säilytysaika',
  'asetukset.sailytysaikaVihje':
    'Kuukausina tilin passivoinnista. Osaamisrekisteri ei poistu. 0 = ei automaattista poistoa.',
  'asetukset.kuukautta': 'kk',

  // --- Salaisuuksien jako (docs/SALAISUUDET.md) ----------------------------
  'navi.salaisuudet': 'Salaisuudet',
  'salaisuudet.otsikko': 'Salaisuuksien jako',
  'salaisuudet.selite':
    'Jaa salasana, avain tai muu teksti linkkinä, jonka voi avata vain kerran. Avaamisen jälkeen sisältö tuhotaan, ja näet milloin ja mistä osoitteesta se avattiin.',
  'salaisuudet.uusi': 'Uusi salaisuus',
  'salaisuudet.omat': 'Omat',
  'salaisuudet.kaikki': 'Kaikkien',
  'salaisuudet.rajaus': 'Näytettävät salaisuudet',
  'salaisuudet.kaikkiTilat': 'Kaikki tilat',
  'salaisuudet.nimi': 'Nimi',
  'salaisuudet.jakaja': 'Jakaja',
  'salaisuudet.luotu': 'Luotu',
  'salaisuudet.vanhenee': 'Vanhenee',
  'salaisuudet.tila': 'Tila',
  'salaisuudet.avattu': 'Avattu',
  'salaisuudet.lukija': 'Avaaja',
  'salaisuudet.pinKaytossa': 'Suojattu PIN-koodilla',
  'salaisuudet.pinYrityksia': (maara: number) =>
    maara === 1 ? '1 väärä PIN-yritys' : `${maara} väärää PIN-yritystä`,
  'salaisuudet.eiSalaisuuksia': 'Ei jaettuja salaisuuksia.',
  'salaisuudet.peru': 'Peru salaisuus',
  'salaisuudet.peruVahvistus': (nimi: string) =>
    `Perutaanko salaisuus ”${nimi}”? Sisältö tuhotaan heti, eikä linkki enää avaudu.`,
  'salaisuudet.perunut': (nimi: string) => `Perui: ${nimi}`,
  'salaisuudet.tila.PENDING': 'Odottaa',
  'salaisuudet.tila.READ': 'Avattu',
  'salaisuudet.tila.EXPIRED': 'Vanhentunut',
  'salaisuudet.tila.REVOKED': 'Peruttu',
  'salaisuudet.tila.DESTROYED': 'Tuhottu',
  'salaisuudet.suljettu': (aika: string) => `Suljettu ${aika}`,
  'salaisuudet.kopioi': 'Kopioi',
  'salaisuudet.kopioitu': 'Kopioitu',
  'salaisuudet.lomake.nimi': 'Nimi',
  'salaisuudet.lomake.nimiEsimerkki': 'Esim. Asiakas Oy – tuotantokannan pääkäyttäjä',
  'salaisuudet.lomake.nimiVihje': 'Vain sinulle. Vastaanottaja ei näe nimeä.',
  'salaisuudet.lomake.sisalto': 'Salaisuus',
  'salaisuudet.lomake.merkkeja': (maara: string, enintaan: string) =>
    `${maara} / ${enintaan} merkkiä`,
  'salaisuudet.lomake.vanhenee': 'Vanhenee',
  'salaisuudet.lomake.muu': 'Muu…',
  'salaisuudet.lomake.vanheneeVihje': (aika: string) =>
    `Linkki vanhenee ${aika}, jos sitä ei avata sitä ennen.`,
  'salaisuudet.lomake.vanheneeVirhe':
    'Valitse aika, joka on 15 minuutista 30 päivään tästä hetkestä.',
  'salaisuudet.ttl.1h': '1 tunti',
  'salaisuudet.ttl.1d': '1 päivä',
  'salaisuudet.ttl.3d': '3 päivää',
  'salaisuudet.ttl.7d': '7 päivää',
  'salaisuudet.ttl.14d': '14 päivää',
  'salaisuudet.ttl.30d': '30 päivää',
  'salaisuudet.lomake.pin': 'Suojaa PIN-koodilla',
  'salaisuudet.lomake.pinVihje':
    'Vastaanottaja tarvitsee linkin lisäksi PIN-koodin. Viisi väärää yritystä tuhoaa salaisuuden.',
  'salaisuudet.lomake.pinArvo': 'Arvo',
  'salaisuudet.lomake.pinOma': 'Oma',
  'salaisuudet.lomake.pinKentta': 'PIN-koodi (4–6 numeroa)',
  'salaisuudet.lomake.pinMuoto': 'PIN-koodissa on 4–6 numeroa.',
  'salaisuudet.lomake.pinTriviaali': 'PIN-koodi on liian helppo arvata.',
  'salaisuudet.lomake.luo': 'Luo linkki',
  'salaisuudet.lomake.luodaan': 'Luodaan…',
  'salaisuudet.valmis.otsikko': 'Linkki on valmis',
  'salaisuudet.valmis.kertaalleen':
    'Linkki näytetään vain nyt. Jos se katoaa, peru salaisuus ja luo uusi.',
  'salaisuudet.valmis.linkki': 'Linkki',
  'salaisuudet.valmis.pin': 'PIN-koodi',
  'salaisuudet.valmis.pinOhje':
    'Lähetä PIN-koodi eri kanavaa pitkin kuin linkki, esimerkiksi tekstiviestillä tai puhelimessa.',
  'salaisuudet.valmis.sulje': 'Valmis',

  'salaisuus.otsikko': 'Jaettu salaisuus',
  'salaisuus.jaettu': (kuka: string, yritys: string) =>
    `${kuka} (${yritys}) on jakanut sinulle salaisuuden.`,
  'salaisuus.kerran':
    'Salaisuuden voi avata vain kerran. Avaamisen jälkeen se poistetaan palvelimelta pysyvästi.',
  'salaisuus.vanhenee': (aika: string) => `Linkki vanhenee ${aika}.`,
  'salaisuus.pin': 'PIN-koodi',
  'salaisuus.pinVihje': 'Jakaja on toimittanut PIN-koodin sinulle erikseen.',
  'salaisuus.nayta': 'Näytä salaisuus',
  'salaisuus.avataan': 'Avataan…',
  'salaisuus.poistettu':
    'Salaisuus on nyt poistettu palvelimelta. Tallenna se ennen kuin suljet sivun.',
  'salaisuus.naytaSisalto': 'Näytä sisältö',
  'salaisuus.piilotaSisalto': 'Piilota sisältö',
  'salaisuus.kopioi': 'Kopioi',
  'salaisuus.kopioitu': 'Kopioitu',
  'salaisuus.vaaraPin': (jaljella: number) =>
    jaljella === 1
      ? 'Väärä PIN-koodi. Yksi yritys jäljellä, ja sen jälkeen salaisuus tuhotaan.'
      : `Väärä PIN-koodi. Yrityksiä jäljellä: ${jaljella}.`,
  'salaisuus.pinPuuttuu': 'Anna PIN-koodi.',
  'salaisuus.joAvattu': (aika: string) => `Tämä salaisuus on jo avattu ${aika}.`,
  'salaisuus.joAvattuVaroitus': 'Jos et avannut sitä itse, ota heti yhteyttä jakajaan.',
  'salaisuus.vanhentunut': (aika: string) => `Salaisuus vanheni ${aika} avaamattomana.`,
  'salaisuus.peruttu': (aika: string) => `Jakaja perui salaisuuden ${aika}.`,
  'salaisuus.tuhottu': 'Salaisuus tuhottiin, koska PIN-koodi annettiin väärin liian monta kertaa.',
  'salaisuus.pyydaUusi': 'Pyydä jakajalta uusi linkki.',
  'salaisuus.eiLoydy': 'Linkki on virheellinen tai salaisuus on poistettu.',
  'salaisuus.katkennut':
    'Linkki on katkennut. Kopioi koko linkki, myös #-merkin jälkeinen osa, ja avaa se uudelleen.',
  'salaisuus.rajoitin': 'Liian monta pyyntöä. Odota minuutti ja yritä uudelleen.',
  'salaisuus.virhe': 'Salaisuuden avaaminen epäonnistui. Yritä uudelleen.',
  'salaisuus.rajapinta': 'Lue rajapinnan kautta',
  'salaisuus.rajapintaOhje':
    'Komento avaa salaisuuden samalla tavalla kuin painike — vain kerran. Vastaus on JSON, jonka content-kentässä on salaisuus.',
  'salaisuus.kieli': 'Kieli',
} satisfies Record<string, string | ((...args: never[]) => string)>;

/** Käännösten muoto: `en.ts` julistetaan tähän tyyppiin. */
export type Sanasto = typeof fi;

export type Avain = keyof Sanasto;
